function LargeFormatConfigureModel () {

}

LargeFormatConfigureModel.prototype = {

    initialize: function (productConfigData, operationGroups) {
        this.productConfigData = productConfigData;
        this.operationGroups = operationGroups;

        this.initializePrivilegedModeFlags();

        this.initializePieceMarginChoice();
        this.initializePieceBleedChoice();
        this.initializeInstallerBleedChoice();
        this.initializeQuantities();
        this.initializeDimensions();
        this.initializeSidesChoice();
        this.initializePrintSubstratesChoice();
        this.initializeMountSubstratesChoice();
        this.initializeFrontLaminatesChoice();
        this.initializeBackLaminatesChoice();
        this.initializeTotalPriceOverrideAmount();
        this.initializeProofsChoice();
        this.initializeTurnaroundTimesChoice();
        this.initializeOperations();
        this.initializeAdditionalFields();
    },

    initializePieceMarginChoice: function () {
        if (this.productConfigData.overrides && this.productConfigData.overrides.pieceMargin) {
            var pieceMargin = this.productConfigData.overrides.pieceMargin;

            this.pieceMarginTop = pieceMargin.pieceMarginTop;
            this.pieceMarginBottom = pieceMargin.pieceMarginBottom;
            this.pieceMarginLeft = pieceMargin.pieceMarginLeft;
            this.pieceMarginRight = pieceMargin.pieceMarginRight;
        } else {
            var defaultPieceMargin = this.productConfigData.defaults.pieceMargin;

            if (defaultPieceMargin) {
                this.pieceMarginTop = defaultPieceMargin.pieceMarginTop;
                this.pieceMarginBottom = defaultPieceMargin.pieceMarginBottom;
                this.pieceMarginLeft = defaultPieceMargin.pieceMarginLeft;
                this.pieceMarginRight = defaultPieceMargin.pieceMarginRight;
            }
        }
    },

    initializePieceBleedChoice: function () {
        if (this.productConfigData.overrides && this.productConfigData.overrides.pieceBleed) {
            var pieceBleed = this.productConfigData.overrides.pieceBleed;

            this.pieceBleedTop = pieceBleed.pieceBleedTop;
            this.pieceBleedBottom = pieceBleed.pieceBleedBottom;
            this.pieceBleedLeft = pieceBleed.pieceBleedLeft;
            this.pieceBleedRight = pieceBleed.pieceBleedRight;
        } else {
            var defaultPieceBleed = this.productConfigData.defaults.pieceBleed;

            if (defaultPieceBleed) {
                this.pieceBleedTop = defaultPieceBleed.pieceBleedTop;
                this.pieceBleedBottom = defaultPieceBleed.pieceBleedBottom;
                this.pieceBleedLeft = defaultPieceBleed.pieceBleedLeft;
                this.pieceBleedRight = defaultPieceBleed.pieceBleedRight;
            }
        }
    },

    initializeInstallerBleedChoice: function () {
        if (this.productConfigData.overrides && this.productConfigData.overrides.installerBleed) {
            var installerBleed = this.productConfigData.overrides.installerBleed;

            this.installerBleedTop = installerBleed.installerBleedTop;
            this.installerBleedBottom = installerBleed.installerBleedBottom;
            this.installerBleedLeft = installerBleed.installerBleedLeft;
            this.installerBleedRight = installerBleed.installerBleedRight;
        } else {
            var defaultInstallerBleed = this.productConfigData.defaults.installerBleed;

            if (defaultInstallerBleed) {
                this.installerBleedTop = defaultInstallerBleed.installerBleedTop;
                this.installerBleedBottom = defaultInstallerBleed.installerBleedBottom;
                this.installerBleedLeft = defaultInstallerBleed.installerBleedLeft;
                this.installerBleedRight = defaultInstallerBleed.installerBleedRight;
            }
        }
    },

    initializeOperations: function () {
        this.operations = [];
        for (var i = 0; i < this.productConfigData.pjc.operations.length; i++) {
            var pjcOp = this.productConfigData.pjc.operations[i];
            var choices = pjcOp.items;
            var defaultChoice = this.prepareDefaultChoice(pjcOp.id, choices);
            var currentOperation = defaultChoice.operation;
            var opChoice = defaultChoice.operationChoice;

            if (this.productConfigData.overrides) {
                currentOperation = this.productConfigData.overrides.operations.find(function (op) {
                    return op.operationId === pjcOp.id;
                });

                if (currentOperation) {
                    if (currentOperation.defaultSelectedChoice) {
                        opChoice = choices.find(function (ch) {
                            return ch.id === currentOperation.defaultSelectedChoice;
                        });

                        if (!opChoice) {
                            opChoice = choices.find(function (ch) {
                                return ch.defaultSelected;
                            });
                        }
                    } else {
                        if (this.getDefaultChoiceId(pjcOp)) {
                            opChoice = null;
                        }
                    }
                } else {
                    defaultChoice = this.prepareDefaultChoice(pjcOp.id, choices);
                    currentOperation = defaultChoice.operation;
                    opChoice = defaultChoice.operationChoice;
                }
            }

            var operation = {
                id: pjcOp.id,
                lpjcOperation: {
                    operation: {
                        id: pjcOp.id,
                        heading: pjcOp.heading,
                        costingOnly: pjcOp.costingOnly
                    },
                    show: pjcOp.show,
                    editable: pjcOp.editable,
                    showTip: pjcOp.showTip,
                    showNoneItem: pjcOp.showNoneItem
                },
                choices: choices,
                choice: opChoice,
                topSide: currentOperation.topSide,
                bottomSide: currentOperation.bottomSide,
                rightSide: currentOperation.rightSide,
                leftSide: currentOperation.leftSide,
                quantity: currentOperation.quantity,
                quantityDivisor: currentOperation.quantityDivisor,
                addOnValue: currentOperation.addOnValue,
                tipContent: pjcOp.tipContent
            };

            this.operations.push(operation);

            if (opChoice && !this.isReorder) {
                this.setOperationChoice(operation.id, operation.choice.id);
            }
        }
    },

    getDefaultChoiceId: function (pjcOp) {
        var defaultSelectedItem = pjcOp.items ? pjcOp.items.find(function (item) {
            return item.defaultSelected;
        }) : null;
        var operationDefaults = (this.productConfigData.defaults.operations || []).find(function (defOp) {
            return defOp.operationId === pjcOp.id;
        });
        var operationItemDefaults = operationDefaults ? operationDefaults.defaultSelectedChoiceId : null;
        var defaultSelectedItemId = defaultSelectedItem ? defaultSelectedItem.id : null;

        return operationItemDefaults || defaultSelectedItemId;
    },

    prepareDefaultChoice: function (operationId, choices) {
        var opDefaults = (this.productConfigData.defaults.operations || []).find(function (op) {
            return op.operationId === operationId;
        }) || {};

        var choice = choices.find(function (ch) {
            return opDefaults ? opDefaults.defaultSelectedChoiceId === ch.id : ch.defaultSelected;
        });

        return {
            operation: opDefaults,
            operationChoice: choice
        };
    },

    getOperationById: function (opId) {
        return this.operations.find(function (op) {
            return op.id === opId;
        });
    },

    setOperationChoice: function (opId, choiceId) {
        var operation = this.getOperationById(opId);

        if (isNaN(choiceId)) {
            operation.choice = null;
            return;
        }

        operation.choice = operation.choices.find(function (ch) {
            return ch.id === choiceId;
        });

        if (operation.choice) {
            operation.topSide = operation.choice.defaultTopSide;
            operation.bottomSide = operation.choice.defaultBottomSide;
            operation.leftSide = operation.choice.defaultLeftSide;
            operation.rightSide = operation.choice.defaultRightSide;
            operation.quantity = operation.choice.defaultQuantity;
            operation.quantityDivisor = operation.choice.defaultQuantityDivisor;
            operation.addOnValue = operation.choice.defaultAddOnValue;
        } else {
            var opDefaults = (this.productConfigData.defaults.operations || []).find(function (op) {
                return op.operationId === operation.id;
            }) || {};

            operation.topSide = opDefaults.topSide;
            operation.bottomSide = opDefaults.bottomSide;
            operation.leftSide = opDefaults.sideLeft;
            operation.rightSide = opDefaults.sideRight;
            operation.quantity = opDefaults.quantity;
            operation.quantityDivisor = opDefaults.quantityDivisor;
            operation.addOnValue = opDefaults.addOnValue;
        }
    },

    setOperationQuantity: function (opId, quantity) {
        var operation = this.getOperationById(opId);

        if (operation) {
            operation.quantity = quantity;
        }
    },

    setOperationQuantityDivisor: function (opId, quantityDivisor) {
        var operation = this.getOperationById(opId);

        if (operation) {
            operation.quantityDivisor = quantityDivisor;
        }
    },

    setOperationAddOnValue: function (opId, addOnValue) {
        var operation = this.getOperationById(opId);

        if (operation) {
            operation.addOnValue = addOnValue;
        }
    },

    getOperationChoiceMap: function () {
        var operationChoices = new Map();

        for (var i = 0; i < this.operations.length; i++) {
            var operation = this.operations[i];
            var operationId = operation.lpjcOperation.operation.id;

            if (operation.choice) {
                operationChoices.set(operationId, operation.choice.id);
            } else {
                if (operation.choice === null) {
                    operationChoices.set(operationId, null);
                }
            }
        }

        return operationChoices;
    },

    getOperationsDetailsMap: function () {
        var operationChoices = new Map();

        this.operations.filter(function (op) {
            return op.choice;
        }).forEach(function (op) {
            operationChoices.set(op.lpjcOperation.operation.id, {
                bottomSide: op.bottomSide,
                leftSide: op.leftSide,
                rightSide: op.rightSide,
                topSide: op.topSide,
                quantity: op.quantity,
                quantityDivisor: op.quantityDivisor,
                addOnValue: op.addOnValue
            });
        });

        return operationChoices;
    },

    initializeAdditionalFields: function () {
        this.additionalFields = {};
        var metadata = this.productConfigData.metadata;
        if (metadata) {
            for (var i = 0; i < metadata.length; i++) {
                var metadataItem = metadata[i];
                if (metadataItem.dataType === 'CB') {
                    this.additionalFields[metadataItem.name] = 'false';
                } else {
                    this.additionalFields[metadataItem.name] = '';
                }
            }
        }

        if (this.productConfigData.overrides && this.productConfigData.overrides.offeringMetadata) {
            var overridesAdditionalFields = this.productConfigData.overrides.offeringMetadata;
            for (var propName in overridesAdditionalFields) {
                var field = overridesAdditionalFields[propName];
                this.additionalFields[field.QUESTION] = field.ANSWER;
            }
        }
    },

    isOverridePricing: function () {
        return this.productConfigData.overridePricing;
    },

    isShowPieceMargin: function () {
        return this.productConfigData.pjc.showPieceMargin;
    },

    isShowPieceMarginTip: function () {
        return this.productConfigData.pjc.showPieceMargin;
    },

    getPieceMarginTip: function () {
        return this.productConfigData.pjc.pieceMarginTip;
    },

    isEditPieceMargin: function () {
        return this.productConfigData.pjc.editPieceMargin;
    },

    isShowPieceBleed: function () {
        return this.productConfigData.pjc.showPieceBleed;
    },

    isShowPieceBleedTip: function () {
        return this.productConfigData.pjc.showPieceBleedTip;
    },

    getPieceBleedTip: function () {
        return this.productConfigData.pjc.pieceBleedTip;
    },

    isEditPieceBleed: function () {
        return this.productConfigData.pjc.editPieceBleed;
    },

    isShowInstallerBleed: function () {
        return this.productConfigData.pjc.showInstallerBleed;
    },

    isShowInstallerBleedTip: function () {
        return this.productConfigData.pjc.showInstallerBleedTip;
    },

    getInstallerBleedTip: function () {
        return this.productConfigData.pjc.installerBleedTip;
    },

    isEditInstallerBleed: function () {
        return this.productConfigData.pjc.editInstallerBleed;
    },

    setPieceMarginTop: function (newValue) {
        this.pieceMarginTop = newValue;
    },

    setPieceMarginBottom: function (newValue) {
        this.pieceMarginBottom = newValue;
    },

    setPieceMarginLeft: function (newValue) {
        this.pieceMarginLeft = newValue;
    },

    setPieceMarginRight: function (newValue) {
        this.pieceMarginRight = newValue;
    },

    setPieceBleedTop: function (newValue) {
        this.pieceBleedTop = newValue;
    },

    setPieceBleedBottom: function (newValue) {
        this.pieceBleedBottom = newValue;
    },

    setPieceBleedLeft: function (newValue) {
        this.pieceBleedLeft = newValue;
    },

    setPieceBleedRight: function (newValue) {
        this.pieceBleedRight = newValue;
    },

    setInstallerBleedTop: function (newValue) {
        this.installerBleedTop = newValue;
    },

    setInstallerBleedBottom: function (newValue) {
        this.installerBleedBottom = newValue;
    },

    setInstallerBleedLeft: function (newValue) {
        this.installerBleedLeft = newValue;
    },

    setInstallerBleedRight: function (newValue) {
        this.installerBleedRight = newValue;
    },

    getPricingPrintJobClassificationId: function () {
        return this.productConfigData.pricingPrintJobClassificationId
            ? this.productConfigData.pricingPrintJobClassificationId
            : this.getPjcId();
    },

    getProductionGroup: function () {
        return this.productConfigData.productionGroup;
    },

    getOfferingName: function () {
        return this.productConfigData.name;
    },

    getPjcId: function () {
        return this.productConfigData.pjc.id;
    },

    isQuoteModePrivileged: function () {
        return configuratorGlobals.isQuoteModePrivileged;
    },

    getEarliestDeliveryDate: function () {
        return configureCommonGlobals.earliestDeliveryDate;
    },

    initializeProofsChoice: function () {
        if (this.productConfigData.overrides && this.productConfigData.overrides.proofId) {
            var proofId = this.productConfigData.overrides.proofId;
            this.proofChoice = this.productConfigData.proofs.find(function (proof) {
                return proof.id === proofId;
            });

            if (!this.proofChoice) {
                this.initProofChoiceWithDefaults();
            }
        } else {
            this.initProofChoiceWithDefaults();
        }
    },

    initProofChoiceWithDefaults: function () {
        var defaultProofId = this.productConfigData.defaults.proofId;
        this.proofChoice = defaultProofId !== undefined ? this.productConfigData.proofs.find(function (proof) {
            return proof.id === defaultProofId;
        }) : null;
    },

    initializeTurnaroundTimesChoice: function () {
        if (this.productConfigData.overrides && this.productConfigData.overrides.turnaroundTimeId) {
            var turnaroundTimeId = this.productConfigData.overrides.turnaroundTimeId;
            this.turnaroundTimeChoice = this.productConfigData.turnaroundTimes.find(function (tt) {
                return tt.id === turnaroundTimeId;
            });

            if (!this.turnaroundTimeChoice) {
                this.initTurnaroundTimeChoiceWithDefaults();
            }
        } else {
            this.initTurnaroundTimeChoiceWithDefaults();
        }
    },

    initTurnaroundTimeChoiceWithDefaults: function () {
        var defaultTurnaroundTimeId = this.productConfigData.defaults.turnaroundTimeId;
        this.turnaroundTimeChoice = defaultTurnaroundTimeId !== undefined ? this.productConfigData.turnaroundTimes.find(function (tt) {
            return tt.id === defaultTurnaroundTimeId;
        }) : null;
    },

    initializePrivilegedModeFlags: function () {
        if (this.isQuoteModePrivileged()) {
            this.productConfigData.pjc.editSides = true;
            this.productConfigData.pjc.editDimensions = true;
            this.productConfigData.pjc.showPrintSubstrate = true;
            this.productConfigData.pjc.editPrintSubstrate = true;
            this.productConfigData.pjc.showMountSubstrate = true;
            this.productConfigData.pjc.editMountSubstrate = true;
            this.productConfigData.pjc.showFrontLaminate = true;
            this.productConfigData.pjc.editFrontLaminate = true;
            this.productConfigData.pjc.showBackLaminate = true;
            this.productConfigData.pjc.editBackLaminate = true;
        }
    },

    initializeQuantities: function () {
        if (this.productConfigData.overrides && this.productConfigData.overrides.quantity) {
            this.qty = this.productConfigData.overrides.quantity;
        } else {
            this.qty = this.productConfigData.defaults.quantity;
        }

        if (this.productConfigData.overrides && this.productConfigData.overrides.quantityPerVersion) {
            this.qtyPerVersion = this.productConfigData.overrides.quantityPerVersion;
        } else {
            this.qtyPerVersion = this.productConfigData.defaults.quantityPerVersion;
        }

        if (this.productConfigData.overrides && this.productConfigData.overrides.versions) {
            this.versions = this.productConfigData.overrides.versions;
        } else {
            var defaultQuantityPerVersions = this.qtyPerVersions || this.qty;

            this.versions = this.productConfigData.defaults.versions || [
                {
                    label: 'Version 1',
                    name: 'Version 1',
                    quantity: defaultQuantityPerVersions
                }
            ];
        }
    },

    getPermissibleObjects: function (allObjects) {
        return allObjects ? allObjects.filter(this.isPermissibleObject.bind(this)) : [];
    },

    isPermissible: function (adminOnly) {
        if (adminOnly) {
            var cuser = typeof globalpageglobals === 'object' && globalpageglobals.cuser;
            return cuser ? cuser.siteAdmin : USER_TYPE === 'SUPPLIER_ADMIN';
        }
        return true;
    },

    isPermissibleObject: function (obj) {
        return !('adminOnly' in obj) || this.isPermissible(obj.adminOnly);
    },

    setQuoteRequestData: function (data) {
        this.quoteRequestData = data;
    },

    generateQuoteRequestData: function () {
        var data = {
            systemOfferingSiteShareId: this.productConfigData.id,
            proofId: this.proofChoice ? this.proofChoice.id : null,
            turnTimeId: this.turnaroundTimeChoice ? this.turnaroundTimeChoice.id : null,
            idWithPrefix: configureCommonGlobals.idWithPrefix,
            orderItemId: this.getOrderItemId(),
            forReorder: this.isReorderOrRequoteMode(),
            siteId: configureCommonGlobals.siteId,
            systemId: configureCommonGlobals.systemId,
            offeringId: getUrlParms().offeringId,
            quoteHistoryId: getUrlParms().OBJECTID3
        };

        var overrides = {};

        overrides.width = this.getWidth() ? this.getWidth() : 0;
        overrides.height = this.getHeight() ? this.getHeight() : 0;

        if (this.sidesChoice) {
            overrides.sides = this.sidesChoice.id;
        }

        if (this.printSubstrateChoice) {
            overrides.printSubstrateAId = this.printSubstrateChoice.id;
        } else {
            overrides.printSubstrateAId = null;
        }

        if (this.mountSubstrateChoice) {
            overrides.mountSubstrateId = this.mountSubstrateChoice.id;
        } else {
            overrides.mountSubstrateId = null;
        }

        if (this.frontLaminateChoice) {
            overrides.frontLaminateId = this.frontLaminateChoice.id;
        } else {
            overrides.frontLaminateId = null;
        }

        if (this.backLaminateChoice) {
            overrides.backLaminateId = this.backLaminateChoice.id;
        } else {
            overrides.backLaminateId = null;
        }

        if (this.versions.length > 1) {
            overrides.versionCount = this.versions.length;
            overrides.qtyPerVersion = this.qtyPerVersion;
            overrides.versionList = this.versions;
        } else {
            overrides.versionCount = this.versions.length;
            data.quantity = this.qty;
        }

        if (this.totalPriceOverrideAmount !== undefined) {
            overrides.totalPriceOverrideAmount = +this.totalPriceOverrideAmount;
        }

        overrides.operationChoices = Object.fromEntries(this.getOperationChoiceMap().entries());
        overrides.operationsDetails = Object.fromEntries(this.getOperationsDetailsMap().entries());

        overrides.pieceMargin = {
            top: this.pieceMarginTop,
            bottom: this.pieceMarginBottom,
            left: this.pieceMarginLeft,
            right: this.pieceMarginRight
        };

        overrides.pieceBleed = {
            top: this.pieceBleedTop,
            bottom: this.pieceBleedBottom,
            left: this.pieceBleedLeft,
            right: this.pieceBleedRight
        };

        overrides.installerBleed = {
            top: this.installerBleedTop,
            bottom: this.installerBleedBottom,
            left: this.installerBleedLeft,
            right: this.installerBleedRight
        };

        data.printJobQuoteSpecOverrides = overrides;
        this.setQuoteRequestData(data);
        return data;
    },

    getOrderItemId: function () {
        return getUrlParms().reorder || getUrlParms().orderItemId || getUrlParms().OBJECTID;
    },

    isReorderOrRequoteMode: function () {
        return (getUrlParms().reorder != null && getUrlParms().p == null) || configureCommonGlobals.REQUOTE_MODE;
    },

    getOfferingId: function () {
        return this.productConfigData.id;
    },

    isShowProofTip: function () {
        return this.productConfigData && this.productConfigData.showProofTip;
    },

    getProofTip: function () {
        return this.productConfigData.proofTip;
    },

    isShowProof: function () {
        return this.productConfigData && this.productConfigData.showProof;
    },

    isShowTurnaroundTime: function () {
        return this.productConfigData && this.productConfigData.showTurnaroundTime;
    },

    isShowTurnaroundTimeTip: function () {
        return this.productConfigData && this.productConfigData.showTurnaroundTimeTip;
    },

    getTurnaroundTimeTip: function () {
        return this.productConfigData.turnaroundTimeTip;
    },

    getProofs: function () {
        return this.productConfigData.proofs;
    },

    setProof: function (value) {
        this.proofChoice = this.productConfigData.proofs.find(function (proof) {
            return proof.id === +value;
        });
    },

    setTurnaroundTime: function (value) {
        this.turnaroundTimeChoice = this.productConfigData.turnaroundTimes.find(function (tt) {
            return tt.id === +value;
        });
    },

    getTurnaroundTimes: function () {
        return this.productConfigData.turnaroundTimes;
    },

    isEditProof: function () {
        return this.productConfigData && this.productConfigData.editProof;
    },

    isEditTurnaroundTime: function () {
        return this.productConfigData && this.productConfigData.editTurnaroundTime;
    },

    getProductAttributes: function () {
        return this.productConfigData.productAttributes;
    },

    initializeSidesChoice: function () {
        var sidesId;
        if (this.productConfigData.overrides && this.productConfigData.overrides.sides) {
            sidesId = this.productConfigData.overrides.sides;
        } else if (this.productConfigData.defaults.sides) {
            sidesId = this.productConfigData.defaults.sides;
        } else {
            sidesId = this.productConfigData.pjc.defaultSides;
        }
        this.sidesChoice = this.getSides().find(function (side) {
            return side.id === sidesId;
        });
    },

    isShowSides: function () {
        return this.productConfigData.pjc.showSides;
    },

    isEditSides: function () {
        return this.productConfigData.pjc.editSides;
    },

    isShowSidesTip: function () {
        return this.productConfigData.pjc.showSidesTip;
    },

    getSidesTip: function () {
        return this.productConfigData.pjc.sidesTip;
    },

    getSidesLabel: function () {
        return 'Sides';
    },

    getSides: function () {
        if (!this.sides) {
            this.sides = [
                { id: 1, name: 'One Sided' },
                { id: 2, name: 'Two Sided' }
            ];
        }
        return this.sides;
    },

    setSides: function (newValue) {
        this.sidesChoice = this.getSides().find(function (side) {
            return side.id === newValue;
        });
    },

    initializePrintSubstratesChoice: function () {
        if (this.productConfigData.overrides && this.productConfigData.overrides.printSubstrateAId) {
            var printSubstrateId = this.productConfigData.overrides.printSubstrateAId;
            this.printSubstrateChoice = this.getPrintSubstrates().find(function (ps) {
                return ps.id === printSubstrateId;
            });

            if (!this.printSubstrateChoice) {
                this.printSubstrateChoice = this.getDefaultPrintSubstrate();
            }
        } else {
            this.printSubstrateChoice = this.getDefaultPrintSubstrate();
        }
    },

    getPrintSubstrates: function () {
        return this.getPermissibleObjects(this.productConfigData.pjc.printSubstrates);
    },

    isShowPrintSubstrate: function () {
        return this.productConfigData.pjc.showPrintSubstrate;
    },

    isShowPrintSubstrateTip: function () {
        return this.productConfigData.pjc.showPrintSubstrateTip;
    },

    isEditPrintSubstrate: function () {
        return this.productConfigData.pjc.editPrintSubstrate;
    },

    isPrintSubstrateRequired: function () {
        return this.productConfigData.pjc.requirePrintSubstrate;
    },

    getPrintSubstrateLabel: function () {
        return 'Print Substrate';
    },

    getDefaultPrintSubstrate: function () {
        var defaultPrintSubstrateId = this.productConfigData.defaults.printSubstrateId;
        return this.getPrintSubstrates().find(function (ps) {
            return ps.id === defaultPrintSubstrateId;
        });
    },

    setPrintSubstrate: function (newValue) {
        var newPrintSubstrate = this.getPrintSubstrates().find(function (ps) {
            return ps.id === +newValue;
        });

        this.printSubstrateChoice = newPrintSubstrate;

        if (newPrintSubstrate && newPrintSubstrate.defaultMountSubstrate) {
            this.setMountSubstrate(newPrintSubstrate.defaultMountSubstrate);
        }
    },

    initializeMountSubstratesChoice: function () {
        if (this.productConfigData.overrides && this.productConfigData.overrides.mountSubstrateId) {
            var mountSubstrateId = this.productConfigData.overrides.mountSubstrateId;
            this.mountSubstrateChoice = this.getMountSubstrates().find(function (ps) {
                return ps.id === mountSubstrateId;
            });

            if (!this.mountSubstrateChoice) {
                this.mountSubstrateChoice = this.getDefaultMountSubstrate();
            }
        } else {
            this.mountSubstrateChoice = this.getDefaultMountSubstrate();
        }
    },

    getMountSubstrates: function () {
        return this.getPermissibleObjects(this.productConfigData.pjc.mountSubstrates);
    },

    isShowMountSubstrate: function () {
        return this.productConfigData.pjc.showMountSubstrate;
    },

    isShowMountSubstrateTip: function () {
        return this.productConfigData.pjc.showMountSubstrateTip;
    },

    isEditMountSubstrate: function () {
        return this.productConfigData.pjc.editMountSubstrate;
    },

    isMountSubstrateRequired: function () {
        return this.productConfigData.pjc.requireMountSubstrate;
    },

    getMountSubstrateLabel: function () {
        return 'Mount Substrate';
    },

    getDefaultMountSubstrate: function () {
        var defaultMountSubstrateId = this.productConfigData.defaults.mountSubstrateId;
        return this.getMountSubstrates().find(function (ps) {
            return ps.id === defaultMountSubstrateId;
        });
    },

    setMountSubstrate: function (newValue) {
        this.mountSubstrateChoice = this.getMountSubstrates().find(function (ms) {
            return ms.id === +newValue;
        });
    },

    initializeFrontLaminatesChoice: function () {
        if (this.productConfigData.overrides && this.productConfigData.overrides.frontLaminateId) {
            var frontLaminateId = this.productConfigData.overrides.frontLaminateId;
            this.frontLaminateChoice = this.getFrontLaminates().find(function (fl) {
                return fl.id === frontLaminateId;
            });

            if (!this.frontLaminateChoice) {
                this.frontLaminateChoice = this.getDefaultFrontLaminate();
            }
        } else {
            this.frontLaminateChoice = this.getDefaultFrontLaminate();
        }
    },

    getFrontLaminates: function () {
        var printSubstrate = this.printSubstrateChoice;

        return this.getPermissibleObjects(this.productConfigData.pjc.frontLaminates).filter(function (fl) {
            if (fl.type && fl.type.name === 'Adhesive') {
                return false;
            }

            if (printSubstrate && printSubstrate.selfAdhesive && fl.type && fl.type.name === 'Hot') {
                return false;
            }

            return true;
        });
    },

    isShowFrontLaminate: function () {
        return this.productConfigData.pjc.showFrontLaminate;
    },

    isShowFrontLaminateTip: function () {
        return this.productConfigData.pjc.showFrontLaminateTip;
    },

    isEditFrontLaminate: function () {
        return this.productConfigData.pjc.editFrontLaminate;
    },

    isFrontLaminateRequired: function () {
        return this.productConfigData.pjc.requireFrontLaminate;
    },

    getFrontLaminateLabel: function () {
        return 'Front Laminate';
    },

    getDefaultFrontLaminate: function () {
        var defaultFrontLaminateId = this.productConfigData.defaults.frontLaminateId;
        return this.getFrontLaminates().find(function (fl) {
            return fl.id === defaultFrontLaminateId;
        });
    },

    setFrontLaminate: function (newValue) {
        this.frontLaminateChoice = this.getFrontLaminates().find(function (fl) {
            return fl.id === +newValue;
        });
    },

    initializeBackLaminatesChoice: function () {
        if (this.productConfigData.overrides && this.productConfigData.overrides.backLaminateId) {
            var backLaminateId = this.productConfigData.overrides.backLaminateId;
            this.backLaminateChoice = this.getBackLaminates().find(function (bl) {
                return bl.id === backLaminateId;
            });

            if (!this.backLaminateChoice) {
                this.backLaminateChoice = this.getDefaultBackLaminate();
            }
        } else {
            this.backLaminateChoice = this.getDefaultBackLaminate();
        }
    },

    laminateTypes: {
        ADHESIVE: 'Adhesive',
        TRANSPARENT_ADHESIVE: 'Transparent Adhesive',
        LAMINATE_TYPE_HOT: 'Hot',
        LAMINATE_TYPE_COLD: 'Cold'
    },

    getBackLaminatesOfTypes: function (types) {
        var allBackLaminates = this.getPermissibleObjects(this.productConfigData.pjc.backLaminates);

        return allBackLaminates.filter(function (bl) {
            return types.includes(bl.type.name);
        });
    },

    getBackLaminatesExcludingTypes: function (types) {
        var allBackLaminates = this.getPermissibleObjects(this.productConfigData.pjc.backLaminates);

        return allBackLaminates.filter(function (bl) {
            return !types.includes(bl.type.name);
        });
    },

    getBackLaminateTypesForFrontLaminate: function () {
        var sides = this.sidesChoice.id;
        var frontLaminate = this.frontLaminateChoice;
        var frontLaminateTypeName = frontLaminate.type.name;

        var types = [];

        if ([this.laminateTypes.LAMINATE_TYPE_COLD, this.laminateTypes.TRANSPARENT_ADHESIVE].includes(frontLaminateTypeName)) {
            types = [this.laminateTypes.LAMINATE_TYPE_COLD, this.laminateTypes.TRANSPARENT_ADHESIVE];
        } else if (frontLaminateTypeName === this.laminateTypes.LAMINATE_TYPE_HOT) {
            types = [this.laminateTypes.LAMINATE_TYPE_HOT, this.laminateTypes.TRANSPARENT_ADHESIVE];
        }

        if (sides === 1) {
            types.push(this.laminateTypes.ADHESIVE);
        }

        return types;
    },

    getBackLaminates: function () {
        var printSubstrate = this.printSubstrateChoice;
        var mountSubstrate = this.mountSubstrateChoice;
        var frontLaminate = this.frontLaminateChoice;
        var sides = this.sidesChoice.id;

        if (sides === 1) {
            if (mountSubstrate) {
                return this.getBackLaminatesOfTypes([this.laminateTypes.ADHESIVE, this.laminateTypes.TRANSPARENT_ADHESIVE]);
            }
            if (printSubstrate && printSubstrate.selfAdhesive) {
                return [];
            }
            if (!frontLaminate) {
                return this.getBackLaminatesOfTypes([this.laminateTypes.ADHESIVE, this.laminateTypes.TRANSPARENT_ADHESIVE, this.laminateTypes.LAMINATE_TYPE_COLD]);
            }

            return this.getBackLaminatesOfTypes(this.getBackLaminateTypesForFrontLaminate());
        }
        if (!mountSubstrate) {
            if (!frontLaminate) {
                return this.getBackLaminatesExcludingTypes([this.laminateTypes.LAMINATE_TYPE_HOT]);
            }

            return this.getBackLaminatesOfTypes(this.getBackLaminateTypesForFrontLaminate());
        }
        var types = printSubstrate && printSubstrate.selfAdhesive ? [this.laminateTypes.ADHESIVE, this.laminateTypes.LAMINATE_TYPE_HOT] : [this.laminateTypes.ADHESIVE];

        return this.getBackLaminatesExcludingTypes(types);
    },

    isShowBackLaminate: function () {
        return this.productConfigData.pjc.showBackLaminate;
    },

    isShowBackLaminateTip: function () {
        return this.productConfigData.pjc.showBackLaminateTip;
    },

    isEditBackLaminate: function () {
        return this.productConfigData.pjc.editBackLaminate;
    },

    isBackLaminateRequired: function () {
        return this.productConfigData.pjc.requireBackLaminate;
    },

    getBackLaminateLabel: function () {
        return 'Back Laminate';
    },

    getDefaultBackLaminate: function () {
        var defaultBackLaminateId = this.productConfigData.defaults.backLaminateId;
        return this.getBackLaminates().find(function (bl) {
            return bl.id === defaultBackLaminateId;
        });
    },

    selectedBackLaminate: function (backLaminates) {
        var choice = this.backLaminateChoice;

        if (choice) {
            var includeChoice = backLaminates.find(function (bl) {
                return bl.id === choice.id;
            });
            if (!includeChoice) {
                this.backLaminateChoice = null;
                if (backLaminates.length > 0) {
                    this.backLaminateChoice = backLaminates[0];
                }
            }
        } else if (!this.isBackLaminateAllowNone() && backLaminates.length > 0) {
            this.backLaminateChoice = backLaminates[0];
        }
        return this.backLaminateChoice;
    },

    setBackLaminate: function (newValue) {
        this.backLaminateChoice = this.getBackLaminates().find(function (bl) {
            return bl.id === +newValue;
        });
    },

    isBackLaminateAllowNone: function () {
        var frontLaminateTypeName = this.frontLaminateChoice ? this.frontLaminateChoice.type.name : null;

        return !!this.mountSubstrateChoice || frontLaminateTypeName !== this.laminateTypes.LAMINATE_TYPE_HOT;
    },

    addVersions: function () {
        var newVersion = this.versions.length + 1;
        this.qty = this.qty + this.qtyPerVersion;
        var label = 'Version ' + newVersion;
        this.versions.push({ label: label, name: label, quantity: this.qtyPerVersion });
        this.recalculateQuantity();
    },

    removeVersions: function () {
        this.versions = [
            {
                label: 'Version 1',
                name: 'Version 1',
                quantity: this.qtyPerVersion
            }
        ];
        this.recalculateQuantity();
    },

    removeVersionAt: function (index) {
        if (+index >= 0 && +index < this.versions.length) {
            this.versions.splice(index, 1);
            this.updateVersionNames();
            this.recalculateQuantity();
        }
    },

    updateVersion: function (index, newName) {
        if (+index >= 0 && +index < this.versions.length) {
            var version = this.versions[index];
            version.name = newName === '' ? version.label : newName;
        }
    },

    recalculateQuantity: function () {
        this.qty = this.versions.map(function (v) {
            return v.quantity;
        }).reduce(function (prev, curr) {
            return prev + curr;
        });
    },

    updateQuantity: function (newValue) {
        this.qty = +newValue;

        this.updateQuantityPerVersion(this.qty);
    },

    updateQuantityPerVersion: function (newValue) {
        var qtyPerVersion = +newValue;
        this.qtyPerVersion = qtyPerVersion;
        this.versions.forEach(function (v) {
            v.quantity = qtyPerVersion;
        });
        this.recalculateQuantity();
    },

    updateVersionCount: function (newValue) {
        var versionCount = +newValue;
        var currentVersionCount = this.versions.length;

        if (versionCount > currentVersionCount) {
            for (var i = currentVersionCount; i < versionCount; i++) {
                this.addVersions();
            }
        } else if (versionCount < currentVersionCount) {
            for (var i = currentVersionCount - 1; i >= versionCount; i--) {
                this.removeVersion(i);
            }
            this.updateVersionNames();
        }
        this.recalculateQuantity();
    },

    removeVersion: function (i) {
        if (this.versions.length > 1) {
            var version = this.versions[i];
            this.versions.splice(this.versions.indexOf(version), 1);
        }
    },

    updateVersionNames: function () {
        for (var i = 0; i < this.versions.length; i++) {
            var version = this.versions[i];
            var oldLabel = version.label;
            var verNum = i + 1;
            version.label = 'Version ' + verNum;

            if (oldLabel === version.name) {
                version.name = version.label;
            }
        }
    },

    initializeDimensions: function () {
        if (this.productConfigData.overrides) {
            var dimensions = this.productConfigData.overrides.dimensions;

            if (this.isQuoteModePrivileged()) {
                this.showCustomDimensions = true;
                this.width = dimensions.width;
                this.height = dimensions.height;
            } else if (dimensions.presetDimensionsId) {
                this.setPresetDimensionsChoice(dimensions.presetDimensionsId);
                if (!this.width || !this.height) {
                    this.width = dimensions.width;
                    this.height = dimensions.height;
                }
            } else {
                if (this.isShowCustomDimensionsByDefault()) {
                    this.showCustomDimensions = true;
                }
                this.width = dimensions.width;
                this.height = dimensions.height;
            }
        } else {
            var pjc = this.productConfigData.pjc;
            var defaultDimensions = this.productConfigData.defaults.dimensions;
            var notDefinedDimensions = defaultDimensions == null && pjc.showCustomDimensionsOption;
            var customDimensionSelected = defaultDimensions != null && defaultDimensions.presetDimensionsId == null;

            this.showCustomDimensions = notDefinedDimensions || customDimensionSelected || this.isQuoteModePrivileged();
            this.initDimensionsChoiceWithDefaults();
        }
    },

    initDimensionsChoiceWithDefaults: function () {
        var defaultDimensions = this.productConfigData.defaults.dimensions;

        if (defaultDimensions) {
            var defaultPresetDimensionsId = defaultDimensions.presetDimensionsId;
            var width = defaultDimensions.width;
            var height = defaultDimensions.height;

            if (defaultPresetDimensionsId) {
                this.setPresetDimensionsChoice(defaultPresetDimensionsId);
            }

            if (width !== undefined) {
                this.width = width;
            }

            if (height !== undefined) {
                this.height = height;
            }
        } else {
            this.width = 0;
            this.height = 0;
        }
    },

    getPresetDimensionsChoice: function () {
        return this.presetDimensionsChoice;
    },

    setPresetDimensionsChoice: function (presetDimensionId) {
        var presetDimensions = this.getPresetDimensions();
        this.presetDimensionsChoice = presetDimensions.find(function (pd) {
            return pd.id === presetDimensionId;
        });

        if (this.presetDimensionsChoice) {
            this.width = this.presetDimensionsChoice.width;
            this.height = this.presetDimensionsChoice.height;
        }
    },

    isShowDimensions: function () {
        return this.productConfigData.pjc.showDimensions;
    },

    getPresetDimensions: function () {
        return this.productConfigData.pjc.presetDimensions;
    },

    isShowDimensionsTip: function () {
        return this.productConfigData.pjc.showDimensionsTip;
    },

    isEditDimensions: function () {
        return this.productConfigData.pjc.editDimensions;
    },

    getDimensionsType: function () {
        return this.productConfigData.pjc.dimensionsType;
    },

    getDimensionsTitle: function () {
        return this.productConfigData.pjc.dimensionsTitle;
    },

    isShowCustomDimensionsByDefault: function () {
        return this.productConfigData && this.productConfigData.pjc.showCustomDimensionsOption;
    },

    isShowCustomDimensions: function () {
        return this.showCustomDimensions;
    },

    setShowCustomDimensions: function (newValue) {
        this.showCustomDimensions = newValue;
    },

    getWidth: function () {
        return this.width;
    },

    getHeight: function () {
        return this.height;
    },

    setWidth: function (width) {
        this.width = width;
        this.tryUpdateMatchedPresetDimensions();
    },

    setHeight: function (height) {
        this.height = height;
        this.tryUpdateMatchedPresetDimensions();
    },

    tryUpdateMatchedPresetDimensions: function () {
        var presetDimensions = this.getPresetDimensions();
        var width = this.width;
        var height = this.height;

        var matched = presetDimensions.find(function (pd) {
            return pd.width === width && pd.height === height;
        });

        if (matched) {
            this.setPresetDimensionsChoice(matched.id);
        } else {
            this.presetDimensionsChoice = null;
        }
    },

    initializeTotalPriceOverrideAmount: function () {
        if (this.productConfigData.overrides && this.productConfigData.overrides.totalPriceOverrideAmount) {
            this.totalPriceOverrideAmount = this.productConfigData.overrides.totalPriceOverrideAmount;
        } else {
            this.totalPriceOverrideAmount = 0;
        }
    },

    getTotalPriceOverrideAmount: function () {
        return this.totalPriceOverrideAmount;
    },

    setTotalPriceOverrideAmount: function (newValue) {
        this.totalPriceOverrideAmount = newValue;
    },

    addAdditionalField: function (question, answer) {
        this.additionalFields[question] = answer;
    },

    isReorder: function () {
        return getUrlParms().reorder;
    },

    getFulfillmentCenterId: function () {
        return this.productConfigData.systemOffering.fulfillmentCenterId;
    }

};

function FrontLaminateManagerAdapter (model) {
    this.model = model;
}

FrontLaminateManagerAdapter.prototype = {

    get choice () {
        var frontLaminateChoice = this.model.frontLaminateChoice;

        if (!frontLaminateChoice) {
            return null;
        }

        var id = frontLaminateChoice.id;
        var typeName = frontLaminateChoice.type ? frontLaminateChoice.type.name : null;
        var name = frontLaminateChoice.name;

        return {
            id: id,
            name: name,
            type: {
                name: typeName
            }
        };
    }

};

function PrintSubstrateManagerAdapter (model) {
    this.model = model;
}

PrintSubstrateManagerAdapter.prototype = {

    get choice () {
        var printSubstrate = this.model.printSubstrateChoice;

        if (!printSubstrate) {
            return null;
        }

        var notes = printSubstrate.notes;
        var selfAdhesive = printSubstrate.selfAdhesive;

        return {
            notes: notes,
            selfAdhesive: selfAdhesive
        };
    }

};

function LargeQuoteAdapter (model, quote) {
    this.model = model;

    for (var prop in quote) {
        this[prop] = quote[prop];
    }
}

LargeQuoteAdapter.prototype = {

    get jobTotalPriceDisplay () {
        return this.priceDisplay;
    },

    get lpjQuote () {
        var deviceId = this.deviceId;
        var deviceName = this.deviceName;
        var totalOunces = this.totalOunces;

        var frontLaminate = this.piece ? {
            type: {
                name: this.piece.frontLaminateType
            },
            productionName: this.piece.frontLaminateProductionName,
            referenceId: this.piece.frontLaminateReferenceId
        } : null;

        var backLaminate = this.piece ? {
            type: {
                name: this.piece.backLaminateType
            },
            productionName: this.piece.backLaminateProductionName,
            referenceId: this.piece.backLaminateReferenceId
        } : null;

        var aPrintSubstrate = this.piece ? {
            productionName: this.piece.aprintSubstrateProductionName,
            referenceId: this.piece.aprintSubstrateReferenceId
        } : null;

        var bPrintSubstrate = this.piece ? {
            productionName: this.piece.bprintSubstrateProductionName,
            referenceId: this.piece.bprintSubstrateReferenceId
        } : null;

        var mountSubstrate = this.piece ? {
            productionName: this.piece.mountSubstrateProductionName,
            referenceId: this.piece.mountSubstrateReferenceId
        } : null;

        var aAdhesiveLaminate = this.piece ? {
            productionName: this.piece.aadhesiveLaminateProductionName,
            referenceId: this.piece.aadhesiveLaminateReferenceId
        } : null;

        var bAdhesiveLaminate = this.piece ? {
            productionName: this.piece.badhesiveLaminateProductionName,
            referenceId: this.piece.badhesiveLaminateReferenceId
        } : null;

        return {
            piece: {
                frontLaminate: frontLaminate,
                backLaminate: backLaminate,
                aPrintSubstrate: aPrintSubstrate,
                bPrintSubstrate: bPrintSubstrate,
                mountSubstrate: mountSubstrate,
                aAdhesiveLaminate: aAdhesiveLaminate,
                bAdhesiveLaminate: bAdhesiveLaminate
            },
            device: {
                id: deviceId,
                name: deviceName
            },
            totalOunces: totalOunces
        };
    }

};

function ExtendedQuoteAdapter (model, quote) {
    this.model = model;
    this.quoteRequestData = Object.assign({}, model.quoteRequestData, {
        additionalFields: model.additionalFields
    });

    for (var prop in quote) {
        this[prop] = quote[prop];
    }
}

ExtendedQuoteAdapter.prototype = {

    get jobTotalPriceDisplay () {
        return this.priceDisplay;
    },

    get lpjQuote () {
        var deviceName = this.deviceName;
        var deviceTypeName = this.deviceTypeName;
        var devicePrice = this.devicePrice;
        var frontLaminatePrice = this.frontLaminatePrice;
        var aPrintSubstrateQuantity = this.aprintSubstrateQuantity;
        var aPrintSubstratePrice = this.aprintSubstratePrice;
        var aAdhesiveLaminatePrice = this.aadhesiveLaminatePrice;
        var mountSubstrateQuantity = this.mountSubstrateQuantity;
        var mountSubstratePrice = this.mountSubstratePrice;
        var bAdhesiveLaminatePrice = this.badhesiveLaminatePrice;
        var bPrintSubstrateQuantity = this.bprintSubstrateQuantity;
        var bPrintSubstratePrice = this.bprintSubstratePrice;
        var backLaminatePrice = this.backLaminatePrice;
        var cuttingPrice = this.cuttingPrice;
        var quantity = this.quantity;
        var versionsPrice = this.versionsPrice;
        var attritionQuantity = this.attritionQuantity;
        var productionQuantity = this.productionQuantity;
        var totalOunces = this.totalOunces;
        var jobCostPrice = this.jobCostPrice;
        var operationsPrice = this.operationsPrice;
        var markupPrice = this.markupPrice;
        var proofPrice = this.proofPrice;
        var turnaroundPrice = this.turnaroundPrice;

        var piece = this.largeFormatPiece || {};
        var operationQuotes = Array.isArray(this.operationQuotes) ? this.operationQuotes : [];
        var operationItem = operationQuotes ? operationQuotes.operationItem : {};
        var costType = operationQuotes && operationQuotes.operationItem ? operationQuotes.operationItem.costType : {};
        var versions = this.versions;

        return {
            javaClassName: 'TBGLPJQuote',
            devicePrice: devicePrice,
            frontLaminatePrice: frontLaminatePrice,
            aPrintSubstrateQuantity: aPrintSubstrateQuantity,
            aPrintSubstratePrice: aPrintSubstratePrice,
            aAdhesiveLaminatePrice: aAdhesiveLaminatePrice,
            mountSubstrateQuantity: mountSubstrateQuantity,
            mountSubstratePrice: mountSubstratePrice,
            bAdhesiveLaminatePrice: bAdhesiveLaminatePrice,
            bPrintSubstrateQuantity: bPrintSubstrateQuantity,
            bPrintSubstratePrice: bPrintSubstratePrice,
            backLaminatePrice: backLaminatePrice,
            cuttingPrice: cuttingPrice,
            quantity: quantity,
            versionsPrice: versionsPrice,
            attritionQuantity: attritionQuantity,
            productionQuantity: productionQuantity,
            totalOunces: totalOunces,
            jobCostPrice: jobCostPrice,
            operationsPrice: operationsPrice,
            markupPrice: markupPrice,
            proofPrice: proofPrice,
            turnaroundPrice: turnaroundPrice,

            device: {
                name: deviceName,
                type: {
                    name: deviceTypeName
                }
            },

            piece: {
                finalWidth: piece.finalWidth,
                finalHeight: piece.finalHeight,
                flatWidth: piece.flatWidth,
                flatHeight: piece.flatHeight,
                outerWidth: piece.outerWidth,
                outerHeight: piece.outerHeight,
                squareFeet: piece.squareFeet,
                squareFeetWastage: piece.squareFeetWastage,
                totalSquareFeet: piece.totalSquareFeet,
                sides: piece.sides,
                frontLaminate: piece.frontLaminateName ? {
                    name: piece.frontLaminateName
                } : null,
                aPrintSubstrate: piece.aprintSubstrateName ? {
                    name: piece.aprintSubstrateName
                } : null,
                aAdhesiveLaminate: piece.aadhesiveLaminateName ? {
                    name: piece.aadhesiveLaminateName
                } : null,
                mountSubstrate: piece.mountSubstrateName ? {
                    name: piece.mountSubstrateName
                } : null,
                bAdhesiveLaminate: piece.badhesiveLaminateName ? {
                    name: piece.badhesiveLaminateName
                } : null,
                bPrintSubstrate: piece.bprintSubstrateName ? {
                    name: piece.bprintSubstrateName
                } : null,
                backLaminate: piece.backLaminateName ? {
                    name: piece.backLaminateName
                } : null
            },

            operationQuotes: operationQuotes ? operationQuotes.map(function (opQuote) {
                return {
                    price: opQuote.price,
                    data: {
                        quantity: opQuote.quantity,
                        topSide: opQuote.topSide,
                        bottomSide: opQuote.bottomSide,
                        leftSide: opQuote.leftSide,
                        rightSide: opQuote.rightSide,
                        addOnValue: opQuote.addOnValue
                    },
                    operation: {
                        name: opQuote.name,
                        heading: opQuote.heading
                    },
                    operationItem: {
                        name: opQuote.operationItem ? opQuote.operationItem.name : null,
                        costType: {
                            id: opQuote.operationItem && opQuote.operationItem.costType ? opQuote.operationItem.costType.id : null
                        }
                    }
                };
            }) : [],

            versions: versions,

            get: function (propertyName) {
                return this[propertyName];
            }
        };
    },

    toJSON: function () {
        return Object.assign({
            jobTotalPriceDisplay: this.jobTotalPriceDisplay,
            lpjQuote: this.lpjQuote
        }, this);
    }
};

function LargeQuoteDataAdapter (model, quote) {
    this.model = model;
    this.quote = quote;

    try {
        var hasQuoteErrors = this.quote !== undefined && this.quote.errors !== undefined && this.quote.errors.length > 0;

        if (hasQuoteErrors) {
            var quoteValidationData = JSON.parse(this.quote.errors[0].detail);
            this.quoteValidation = new Validation(quoteValidationData);
        } else if (this.quote.validation) {
            var fieldMessages = this.quote.validation.fieldMessages ? this.quote.validation.fieldMessages.map(function (fm) {
                return {
                    fieldName: fm.fieldName,
                    value: fm.message
                };
            }) : [];
            this.quoteValidation = new Validation({
                globalErrorMessages: this.quote.validation.globalErrorMessages,
                globalInfoMessages: this.quote.validation.globalInfoMessages,
                jobQuoteFieldMessages: fieldMessages
            });
        } else {
            this.quoteValidation = new Validation({});
        }
    } catch (e) {
        this.quoteValidation = new Validation({});
    }
}

LargeQuoteDataAdapter.prototype = {
    setProperty: function () {
    },

    get privilegedMode () {
        return this.model.isQuoteModePrivileged();
    },

    get externallyGenerated () {
        return false;
    },

    get versions () {
        return this.model.versions;
    },

    get quantityLabel () {
        return 'Total Quantity';
    },

    get versionQuantityLabel () {
        return 'Quantity per Version';
    },

    get quantity () {
        return this.model.qty;
    },

    get quantityPerVersion () {
        return this.model.qtyPerVersion;
    },

    updateQuantityPerVersion: function (newValue) {
        this.model.updateQuantityPerVersion(newValue);
    },

    updateVersionCount: function (newValue) {
        this.model.updateVersionCount(newValue);
    },

    updateQuantity: function (newValue) {
        this.model.updateQuantity(newValue);
    },

    get versionCount () {
        return this.model.versions.length;
    },

    addVersions: function () {
        this.model.addVersions();
    },

    removeVersions: function () {
        this.model.removeVersions();
    },

    removeVersionAt: function (index) {
        this.model.removeVersionAt(index);
    },

    updateVersion: function (index, newName) {
        this.model.updateVersion(index, newName);
    },

    addFieldError: function (fieldName, value) {
        this.validation.addFieldError(fieldName, value);
    },

    clearFieldErrors: function (fieldName) {
        this.validation.clearFieldErrors(fieldName);
    },

    addGlobalError: function (error) {
        this.validation.addGlobalError(error);
    },

    clearGlobalErrors: function () {
        this.validation.clearGlobalErrors();
    },

    get validation () {
        return this.quoteValidation;
    },
    get proof () {
        return this.model.proofChoice;
    },

    setProof: function (newValue) {
        this.model.setProof(newValue);
    },

    get turnaroundTime () {
        return this.model.turnaroundTimeChoice;
    },

    setTurnaroundTime: function (newValue) {
        this.model.setTurnaroundTime(newValue);
    },

    get device () {
        var deviceId = this.quote.deviceId;
        return {
            id: deviceId
        };
    },

    get multipleVersions () {
        return this.model.versions.length > 1;
    },

    get width () {
        return this.model.width;
    },

    get height () {
        return this.model.height;
    },

    get jobSpecOverrides () {
        return this.model.generateQuoteRequestData().printJobQuoteSpecOverrides;
    },

    get metadata () {
        return this.model.productConfigData.metadata;
    },

    setAdditionalField: function (question, answer) {
        this.model.addAdditionalField(question, answer);
    },

    get additionalFields () {
        return this.model.additionalFields;
    }

};

function OperationsManagerAdapter (model) {
    this.model = model;
}

OperationsManagerAdapter.prototype = {
    get operations () {
        return this.model.operations;
    },

    getOperationAt: function (index) {
        return index >= 0 && index < this.model.operations.length ? this.model.operations[index] : null;
    }
};

function LargePrintJobClassificationAdapter (model) {
    this.model = model;

    var pjc = this.model.productConfigData.pjc;

    for (var prop in pjc) {
        this[prop] = pjc[prop];
    }

    this.adaptOperations();
}

LargePrintJobClassificationAdapter.prototype = {

    adaptOperations: function () {
        var operations = this.operations;
        if (!operations) {
            return;
        }

        for (var i = 0; i < operations.length; i++) {
            this.operations[i].operation = {
                id: this.operations[i].id,
                items: this.operations[i].items
            };
        }
    }

};

function OfferingAdapter (model) {
    this.model = model;
}

OfferingAdapter.prototype = {

    get id () {
        return this.model.getOfferingId();
    },

    get name () {
        return this.model.getOfferingName();
    },

    get quoteDefaults () {
        return this.model.getQuoteDefaults();
    },

    get systemLevelOffering () {
        return true;
    },

    get overridePricing () {
        return this.model.isOverridePricing();
    },

    get earliestDeliveryDate () {
        return this.model.getEarliestDeliveryDate();
    },

    get pricingLargeFormatPrintJobClassification () {
        return {
            id: this.model.getPricingPrintJobClassificationId()
        };
    },

    get productionGroup () {
        var productionGroup = this.model.getProductionGroup();
        return {
            id: productionGroup ? productionGroup.id : null,
            name: productionGroup ? productionGroup.name : null
        };
    },

    get systemOffering () {
        var model = this.model;
        var adapter = this;
        return {
            get pricingLargeFormatPrintJobClassification () {
                return {
                    id: model.getPricingPrintJobClassificationId()
                };
            },

            get fulfillmentCenter () {
                return {
                    id: model.getFulfillmentCenterId()
                };
            },

            isServiceTypePOD: function () {
                return true;
            },

            get showProofTip () {
                return model.isShowProofTip();
            },

            get proofTip () {
                return model.getProofTip();
            },

            get showTurnaroundTimeTip () {
                return model.isShowTurnaroundTimeTip();
            },

            get turnaroundTimeTip () {
                return model.getTurnaroundTimeTip();
            },

            get turnaroundTimes () {
                return adapter.getPublishedTurnaroundTimes();
            }
        };
    },

    get turnaroundTimes () {
        return this.getPublishedTurnaroundTimes();
    },

    get productAttributesValue () {
        return this.model.getProductAttributes();
    },

    isLargeFormatPOD: function () {
        return true;
    },

    isSmallFormatPOD: function () {
        return false;
    },

    getPublishedShowProof: function () {
        return this.model.isShowProof();
    },

    getPublishedShowTurnaroundTime: function () {
        return this.model.isShowTurnaroundTime();
    },

    getPublishedProofs: function () {
        var proofs = this.model.getProofs();
        return proofs ? proofs.map(function (proof) {
            return { proof: proof };
        }) : [];
    },

    getPublishedTurnaroundTimes: function () {
        var turnaroundTimes = this.model.getTurnaroundTimes();
        return turnaroundTimes ? turnaroundTimes.map(function (tt) {
            return { turnaroundTime: tt };
        }) : [];
    },

    getPublishedEditProof: function () {
        return this.model.isEditProof();
    },

    getPublishedEditTurnaroundTime: function () {
        return this.model.isEditTurnaroundTime();
    }

};

function Validation (quoteValidationData) {
    var globalErrorMessages = quoteValidationData.globalErrorMessages || [];

    this.hasGlobalErrorMessages = globalErrorMessages.length > 0;
    this.globalErrorMessages = globalErrorMessages.map(function (msg) {
        return {
            value: msg
        };
    });

    var globalInfoMessages = quoteValidationData.globalInfoMessages || [];

    this.hasGlobalInfoMessages = globalInfoMessages.length > 0;
    this.globalInfoMessages = globalInfoMessages.map(function (msg) {
        return {
            value: msg
        };
    });

    var jobQuoteFieldMessages = quoteValidationData.jobQuoteFieldMessages || [];

    this.hasJobQuoteMessages = quoteValidationData.length > 0;
    this.jobQuoteFieldMessages = jobQuoteFieldMessages;
}

Validation.prototype = {

    addFieldError: function (fieldName, value) {
        this.jobQuoteFieldMessages.push({ fieldName: fieldName, value: value });
    },

    clearFieldErrors: function (fieldName) {
        var jobQuoteFieldMessages = this.jobQuoteFieldMessages;
        var fieldErrors = jobQuoteFieldMessages.filter(function (msg) {
            return msg.fieldName === fieldName;
        });

        fieldErrors.forEach(function (error) {
            jobQuoteFieldMessages.splice(jobQuoteFieldMessages.indexOf(error), 1);
        });
    },

    addGlobalError: function (error) {
        this.globalErrorMessages.push({ value: error });
        this.hasGlobalErrorMessages = true;
    },

    clearGlobalErrors: function () {
        this.globalErrorMessages = [];
        this.hasGlobalErrorMessages = false;
    }
};

var controller = {
    mode: controllerMode.FIELD_CHANGE_QUOTE,
    model: new LargeFormatConfigureModel(),
    fieldChangeQuotePending: false,
    getFullQuotePending: false,

    QUOTE_URLS: {
        DEFAULT: '/rest/storefront/products/quotes',
        EXTENDED: '/rest/internal/supplierAdmin/products/quotes/extended',
        CUSTOM: '/rest/internal/supplierAdmin/products/quotes/custom',
        REQUOTE: '/rest/internal/supplierAdmin/products/quotes/requote'
    },
    USER_TYPES: {
        SUPPLIER_ADMIN: 'SUPPLIER_ADMIN'
    },

    enterFullQuoteMode: function () {
        this.mode = controllerMode.FULL_QUOTE;
        this.getFullQuotePending = false;
        return this.mode;
    },
    exitFullQuoteMode: function (sourceContextConfigChangeDetails) {
        if (this.mode == controllerMode.FIELD_CHANGE_QUOTE) {
            return this.mode;
        }
        this.mode = controllerMode.FIELD_CHANGE_QUOTE;
        if (this.fieldChangeQuotePending && !this.getFullQuotePending) {
            this.getFullQuotePending = true;
            setTimeout(function () {
                controller.getFullQuote(sourceContextConfigChangeDetails);
            }, 1);
        }
        return this.mode;
    },
    fullQuoteFlags: {
        isCustomDimensions: false
    },
    initialize: function () {
        Promise.all([this.fetchPjc(), this.fetchOperationGroups()]).then(function (data) {
            var productConfigData = data[0];
            var operationGroups = data[1].largeFormatOperationGroupSet !== null ? data[1].largeFormatOperationGroupSet.operationGroups : null;
            controller.initializeModelAndDisplay(productConfigData, operationGroups);
        });
    },
    fetchPjc: function () {
        var self = this;

        return new Promise(function (resolve, reject) {
            var supplierAdmin = USER_TYPE === 'SUPPLIER_ADMIN';

            var storefrontPath = '/api/product-configuration-service/product-configurations/offerings/';
            var adminPath = '/api/product-configuration-service/supplierAdmin/product-configurations/offerings/';

            var offeringPath = supplierAdmin ? adminPath : storefrontPath;
            var offeringsURL = offeringPath + configureCommonGlobals.idWithPrefix;

            var queryParams = [];

            if (supplierAdmin) {
                // Pages use different conventions. Some of them use OBJECTID to pass orderItemId, while others use orderItemId
                // Params from Order details requote frame
                if (hasValue(getUrlParms().OBJECTID) || hasValue(getUrlParms().OBJECTID2) || hasValue(getUrlParms().OBJECTID3)) {
                    if (hasValue(getUrlParms().OBJECTID)) {
                        queryParams.push('orderItemId=' + getUrlParms().OBJECTID);
                    }

                    if (hasValue(getUrlParms().OBJECTID2)) {
                        queryParams.push('productionRunId=' + getUrlParms().OBJECTID2);
                    }

                    if (hasValue(getUrlParms().OBJECTID3)) {
                        queryParams.push('quoteHistoryId=' + getUrlParms().OBJECTID3);
                    }
                }
                if (hasValue(getUrlParms().orderItemId)) {
                    queryParams.push('orderItemId=' + getUrlParms().orderItemId);
                }
            } else {
                if (getUrlParms().reorder != null) {
                    queryParams.push('orderItemId=' + getUrlParms().reorder);

                    // r=y is the site user's "reuse the original's artwork" choice. The product
                    // configuration service needs it to decide whether the share's reorderProof
                    // default replaces the proof inherited from the original item. Sent only on
                    // this storefront branch - a supplier-admin requote must keep inheriting.
                    // TTI-20736.
                    //
                    // p (the project id) must be absent. r=y alone does not mean "reorder": the
                    // "edit this item's configuration" URL for an item already in a project
                    // hardcodes r=y and always carries p (RegularOrderItemDTOMapperImpl:328,336),
                    // and that routes to updateProduct rather than a reorder. Without the p check,
                    // editing a project item's quantity would silently reset its proof. This is the
                    // same condition isReorderOrRequoteMode uses, and the same one behind the
                    // forReorder flag sent alongside this request (configurePODController.js:521).
                    if (getUrlParms().r === 'y' && getUrlParms().p == null) {
                        queryParams.push('reorderReuseFiles=true');
                    }
                }

                if (getUrlParms().sharedProductConfig) {
                    queryParams.push('sharedProductConfig=' + getUrlParms().sharedProductConfig);
                }
            }

            var queryParamsString = queryParams.join('&');

            if (queryParamsString.length > 0) {
                offeringsURL = offeringsURL + '?' + queryParamsString;
            }

            var accessTokenPromise = supplierAdmin ? self.fetchAccessToken() : Promise.resolve();

            accessTokenPromise.then(function (token) {
                $.ajax({
                    url: offeringsURL,
                    method: 'GET',
                    accept: 'application/json',
                    beforeSend: function (xhr) {
                        if (hasValue(token)) {
                            xhr.setRequestHeader('Authorization', 'Bearer ' + token);
                        }
                    },
                    success: function (productConfigData) {
                        resolve(productConfigData);
                    },
                    error: function () {
                        console.error('Error fetching product and PJC');
                        reject();
                    }
                });
            }).catch(function () {
                reject();
            });
        });
    },
    fetchOperationGroups: function () {
        return new Promise(function (resolve, reject) {
            var siteId = configureCommonGlobals.siteId;

            $.ajax({
                url: '/api/site-service/sites/' + siteId + '/config/operation-group-sets',
                method: 'GET',
                accept: 'application/json',
                success: function (operationGroups) {
                    resolve(operationGroups);
                },
                error: function () {
                    console.error('Error fetching operation groups');
                    reject();
                }
            });
        });
    },
    fetchAccessToken: function () {
        return new Promise(function (resolve, reject) {
            $.ajax({
                url: '/rest/internal/supplierAdmin/adminUsers/jwtFromSession',
                method: 'GET',
                accept: 'application/json',
                success: function (response) {
                    resolve(response.apiToken);
                },
                error: function () {
                    console.error('Error fetching operation groups');
                    reject();
                }
            });
        });
    },
    initializeModelAndDisplay: function (productConfigData, operationGroups) {
        this.model.initialize(productConfigData, operationGroups);

        this.initializeAdapters();

        var configChangeDetails = {
            context: 'init',
            category: confUtil.INIT
        };

        this.getQuote(false, function () {
            this.generateUI(configChangeDetails, { list: [] });

            configureEvents.onCalcLoaded();
            configureEvents.onQuoteUpdated(configChangeDetails);
            controller.onLargeQuoteComplete(configureglobals.cquote != null);
        }.bind(this));

        if (typeof shippingCalcWidgetController == 'object') {
            shippingCalcWidgetController.initialize();
        }
    },
    initializeAdapters: function () {
        configureglobals.set('clpjc', new LargePrintJobClassificationAdapter(this.model));
        configureglobals.set('coffering', new OfferingAdapter(this.model));
        configureglobals.set('coperationsmgr', new OperationsManagerAdapter(this.model));
        configureglobals.set('coperationdata', { list: this.model.operations });
        configureglobals.set('coperationgroupset', { operationGroups: this.model.operationGroups });
        configureglobals.set('cfrontlaminatesmgr', new FrontLaminateManagerAdapter(this.model));
        configureglobals.set('cprintsubstratesmgr', new PrintSubstrateManagerAdapter(this.model));
    },
    generateUI: function () {
        this.display();
    },
    onLogin: function () {
        controller.getQuote(true, function () {
            var configChangeDetails = {
                context: 'onLogin',
                category: confUtil.LOGIN
            };
            configureEvents.onQuoteUpdated(configChangeDetails);
        });
    },
    getSideId: function (id) {
        var csides = configureglobals.csides.list;
        for (var i = 0; i < csides.length; i++) {
            var cside = csides[i];
            if (cside.id == id) {
                return cside;
            }
        }
        return null;
    },
    generateSides: function () {
        if (this.model.isShowSides() && dynamic.divIdExists('sides')) {
            var fieldName = 'SIDESDD';
            var content = '';
            var error = common.validation.hasJobQuoteFieldMessagesFor(fieldName);
            var csides = this.model.getSides();

            var cselectedsides = this.model.sidesChoice;

            var help = '';

            if (this.model.isShowSidesTip()) {
                help = tags.a('', 'javascript:help.tip(configureglobals.clpjc,\'sidesTip\',\'' + TBGBOLargeFormatTip.SIDES + '\')', {
                    id: 'sidesTip',
                    cssClass: 'quoteHelp',
                    tabindex: '-1',
                    title: 'More Information'
                });
            }

            if (this.model.isEditSides()) {
                content += help + '<label class="config">' + this.model.getSidesLabel() + '</label>';
                content += forms.dd(fieldName, csides, cselectedsides, {
                    showNullOption: false,
                    cssClass: 'configSelect' + (error ? ' error' : ''),
                    onchange: 'controller.setSides()'
                });
                if (error) {
                    content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
                }
            } else {
                content += help + '<label class="config">' + this.model.getSidesLabel() + '</label>';
                content += tags.div(cselectedsides.name, {
                    cssClass: 'noEdit'
                });
            }
            common.setOptionDiv('sides', content);
        }
    },
    setSides: function () {
        var newValue = getDropDownSelectedValue('SIDESDD', document);

        var configChangeDetails = {
            context: 'setSides',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'SIDESDD',
            fieldType: 'DD',
            previousValue: null,
            newValue: newValue
        };

        this.model.setSides(+newValue);

        configureEvents.onCalcChanged(configChangeDetails);

        this.updateQuote(configChangeDetails);
    },
    generateDimensions: function () {
        controller.fullQuoteFlags.isCustomDimensions = false;

        if ((this.model.isShowDimensions() || this.model.isQuoteModePrivileged()) && dynamic.divIdExists('dimensions')) {
            var widthName = 'WIDTHEF';
            var heightName = 'HEIGHTEF';
            var dimensionsName = 'PRESETDIMENSIONSDD';
            var customType = configureCommonGlobals.CUSTOM_DIMENSIONS;
            var presetType = configureCommonGlobals.PRESET_DIMENSIONS;

            var presetDimensions = this.model.getPresetDimensions();
            var customDimensionsOption = this.model.isShowCustomDimensions();
            var presetDimensionsChoice = this.model.getPresetDimensionsChoice();
            var width = this.model.getWidth();
            var height = this.model.getHeight();
            var content = '';
            var error = common.validation.hasJobQuoteFieldMessagesFor(widthName);
            var help = '';

            if (this.model.isShowDimensionsTip()) {
                help = tags.a('', 'javascript:help.tip(configureglobals.clpjc,\'dimensionsTip\',\'' + TBGBOLargeFormatTip.DIMENSIONS + '\')', {
                    id: 'dimensionsTip',
                    cssClass: 'quoteHelp',
                    tabindex: '-1',
                    title: 'More Information'
                });
            }

            if (this.model.isEditDimensions()) {
                content += help + '<label class="config">' + this.model.getDimensionsTitle() + '</label>';

                var dimType = this.model.getDimensionsType();

                if (dimType == customType || customDimensionsOption) {
                    controller.fullQuoteFlags.isCustomDimensions = true;
                    content += '<div class="customDimensions">';
                    content += forms.ef(widthName, width, {
                        size: 5,
                        cssClass: 'configField' + (error ? ' error' : ''),
                        onfocus: 'common.efFocus(\'' + widthName + '\',\'dimensions\', \'dimensionsFocus\')',
                        onblur: 'controller.setWidth()'
                    });
                    content += ' &#215; ';
                    content += forms.ef(heightName, height, {
                        size: 5,
                        cssClass: 'configField' + (error ? ' error' : ''),
                        onfocus: 'common.efFocus(\'' + heightName + '\',\'dimensions\', \'dimensionsFocus\')',
                        onblur: 'controller.setHeight()'
                    });
                    content += '<span id="dimensionsFocus" class="changeFocusButton"><!-- dynamic --></span>';
                    content += '</div>';

                    if (dimType == presetType && customDimensionsOption) {
                        content += '<br />';
                        content += tags.a('Use Preset Dimensions', 'javascript:controller.setCustomDimensionsOption(false)', {
                            cssClass: 'togglePreset presets'
                        });
                    }
                } else if (dimType == presetType) {
                    var ddoptions = {
                        showNullOption: false,
                        cssClass: 'configSelect' + (error ? ' error' : ''),
                        onchange: 'controller.setDimensions()',
                        propertyFunction: function (object) {
                            return object.width + ' x ' + object.height;
                        }
                    };
                    content += forms.dd(dimensionsName, presetDimensions, presetDimensionsChoice, ddoptions);
                    if (dimType == presetType && this.model.isShowCustomDimensionsByDefault()) {
                        content += tags.a('Use Custom Dimensions', 'javascript:controller.setCustomDimensionsOption(true)', {
                            cssClass: 'togglePreset customs'
                        });
                    }
                }
                if (error) {
                    content += common.validation.generateJobQuoteFieldMessagesFor(widthName);
                }
            } else {
                content += help + '<label class="config">' + this.model.getDimensionsTitle() + '</label>';
                content += tags.div(this.model.getWidth() + ' x ' + this.model.getHeight(), {
                    cssClass: 'noEdit'
                });
            }
            common.setOptionDiv('dimensions', content);
        }
    },
    setCustomDimensionsOption: function (bool) {
        var configChangeDetails = {
            context: 'setCustomDimensionsOption',
            category: confUtil.OPTION_CHANGE,
            value: bool,
            previousValue: !bool,
            newValue: bool
        };

        this.model.setShowCustomDimensions(bool);

        configureEvents.onCalcChanged(configChangeDetails);

        if (bool === false) {
            var presetDimensionsChoices = this.model.getPresetDimensions();
            var currentWidth = this.model.getWidth();
            var currentHeight = this.model.getHeight();
            var dimensionChoice = presetDimensionsChoices.find(function (dimension) {
                return dimension.width === currentWidth && dimension.height === currentHeight;
            });

            if (dimensionChoice) {
                this.model.setPresetDimensionsChoice(dimensionChoice.id);
            } else {
                this.model.initDimensionsChoiceWithDefaults();
            }
        }

        this.updateQuote(configChangeDetails);
    },
    setDimensions: function () {
        var newValue = getDropDownSelectedValue('PRESETDIMENSIONSDD', document);

        var configChangeDetails = {
            context: 'setDimensions',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'PRESETDIMENSIONSDD',
            fieldType: 'DD',
            previousValue: null,
            newValue: newValue
        };

        this.model.setPresetDimensionsChoice(+newValue);

        configureEvents.onCalcChanged(configChangeDetails);

        this.updateQuote(configChangeDetails);
    },
    generatePrintSubstrates: function () {
        if (this.model.isShowPrintSubstrate() && dynamic.divIdExists('printSubstrates')) {
            var fieldName = 'PRINTSUBSTRATEDD';
            var content = '';
            var error = common.validation.hasJobQuoteFieldMessagesFor(fieldName);

            var cprintsubstrates = this.model.getPrintSubstrates();

            var selectedprintsubstrate = this.model.printSubstrateChoice;
            var help = '';

            if (this.model.isShowPrintSubstrateTip()) {
                help = tags.a('', 'javascript:help.tip(configureglobals.clpjc,\'printSubstrateTip\',\'' + TBGBOLargeFormatTip.PRINTSUBSTRATES + '\')', {
                    id: 'printSubstrateTip',
                    cssClass: 'quoteHelp',
                    tabindex: '-1',
                    title: 'More Information'
                });
            }

            if (this.model.isEditPrintSubstrate()) {
                content += help + '<label class="config">' + this.model.getPrintSubstrateLabel() + '</label>';
                content += forms.dd(fieldName, cprintsubstrates, selectedprintsubstrate, {
                    showNullOption: !this.model.isPrintSubstrateRequired(),
                    nullOption: 'None',
                    cssClass: 'configSelect' + (error ? ' error' : ''),
                    onchange: 'controller.setPrintSubstrate()'
                });
                if (error) {
                    content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
                }
            } else {
                var cprintsubstrate = this.model.getDefaultPrintSubstrate();
                if (cprintsubstrate != null) {
                    content += help + '<label class="config">' + this.model.getPrintSubstrateLabel() + '</label>';
                    content += tags.div(cprintsubstrate.name, {
                        cssClass: 'noEdit'
                    });
                }
            }
            common.setOptionDiv('printSubstrates', content);
        }
    },
    setPrintSubstrate: function () {
        var newValue = getDropDownSelectedValue('PRINTSUBSTRATEDD', document);

        var configChangeDetails = {
            context: 'setPrintSubstrate',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'PRINTSUBSTRATEDD',
            fieldType: 'DD',
            previousValue: null,
            newValue: newValue
        };

        this.model.setPrintSubstrate(+newValue);

        configureEvents.onCalcChanged(configChangeDetails);

        this.updateQuote(configChangeDetails);
    },
    generateMountSubstrates: function () {
        if (this.model.isShowMountSubstrate() && dynamic.divIdExists('mountSubstrates')) {
            var fieldName = 'MOUNTSUBSTRATEDD';
            var content = '';
            var error = common.validation.hasJobQuoteFieldMessagesFor(fieldName);

            var clist = this.model.getMountSubstrates();
            var cselected = this.model.mountSubstrateChoice;

            var help = '';

            if (this.model.isShowMountSubstrateTip()) {
                help = tags.a('', 'javascript:help.tip(configureglobals.clpjc,\'mountSubstrateTip\',\'' + TBGBOLargeFormatTip.MOUNTSUBSTRATES + '\')', {
                    id: 'mountSubstrateTip',
                    cssClass: 'quoteHelp',
                    tabindex: '-1',
                    title: 'More Information'
                });
            }

            if (this.model.isEditMountSubstrate()) {
                content += help + '<label class="config">' + this.model.getMountSubstrateLabel() + '</label>';
                content += forms.dd(fieldName, clist, cselected, {
                    showNullOption: !this.model.isMountSubstrateRequired(),
                    nullOption: 'None',
                    cssClass: 'configSelect' + (error ? ' error' : ''),
                    onchange: 'controller.setMountSubstrate()'
                });
                if (error) {
                    content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
                }
            } else {
                var cdefault = this.model.getDefaultMountSubstrate();
                if (cdefault != null) {
                    content += help + '<label class="config">' + this.model.getMountSubstrateLabel() + '</label>';
                    content += tags.div(cdefault.name, {
                        cssClass: 'noEdit'
                    });
                }
            }
            common.setOptionDiv('mountSubstrates', content);
        }
    },
    setMountSubstrate: function () {
        var newValue = getDropDownSelectedValue('MOUNTSUBSTRATEDD', document);

        var configChangeDetails = {
            context: 'setMountSubstrate',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'MOUNTSUBSTRATEDD',
            fieldType: 'DD',
            previousValue: null,
            newValue: newValue
        };

        this.model.setMountSubstrate(+newValue);

        configureEvents.onCalcChanged(configChangeDetails);

        this.updateQuote(configChangeDetails);
    },
    generateFrontLaminates: function () {
        if (this.model.isShowFrontLaminate() && dynamic.divIdExists('frontLaminate')) {
            var fieldName = 'FRONTLAMINATEDD';
            var content = '';
            var error = common.validation.hasJobQuoteFieldMessagesFor(fieldName);

            var clist = this.model.getFrontLaminates();
            var cselected = this.model.frontLaminateChoice;

            var help = '';

            if (this.model.isShowFrontLaminateTip()) {
                help = tags.a('', 'javascript:help.tip(configureglobals.clpjc,\'frontLaminateTip\',\'' + TBGBOLargeFormatTip.FRONTLAMINATES + '\')', {
                    id: 'frontLaminateTip',
                    cssClass: 'quoteHelp',
                    tabindex: '-1',
                    title: 'More Information'
                });
            }

            if (this.model.isEditFrontLaminate()) {
                content += help + '<label class="config">' + this.model.getFrontLaminateLabel() + '</label>';
                content += forms.dd(fieldName, clist, cselected, {
                    showNullOption: !this.model.isFrontLaminateRequired(),
                    nullOption: 'None',
                    cssClass: 'configSelect' + (error ? ' error' : ''),
                    onchange: 'controller.setFrontLaminate()'
                });
                if (error) {
                    content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
                }
            } else {
                var cdefault = this.model.getDefaultFrontLaminate();

                if (cdefault != null) {
                    content += help + '<label class="config">' + this.model.getFrontLaminateLabel() + '</label>';
                    content += tags.div(cdefault.name, {
                        cssClass: 'noEdit'
                    });
                }
            }
            common.setOptionDiv('frontLaminate', content);
        }
    },
    setFrontLaminate: function () {
        var newValue = getDropDownSelectedValue('FRONTLAMINATEDD', document);

        var configChangeDetails = {
            context: 'setFrontLaminate',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'FRONTLAMINATEDD',
            fieldType: 'DD',
            previousValue: null,
            newValue: newValue
        };

        this.model.setFrontLaminate(+newValue);

        configureEvents.onCalcChanged(configChangeDetails);

        this.updateQuote(configChangeDetails);
    },
    generateBackLaminates: function () {
        if (this.model.isShowBackLaminate() && dynamic.divIdExists('backLaminate')) {
            var fieldName = 'BACKLAMINATEDD';
            var content = '';
            var error = common.validation.hasJobQuoteFieldMessagesFor(fieldName);

            var clist = this.model.getBackLaminates();

            var cselected = this.model.selectedBackLaminate(clist);

            var help = '';

            if (this.model.isShowBackLaminateTip()) {
                help = tags.a('', 'javascript:help.tip(configureglobals.clpjc,\'backLaminateTip\',\'' + TBGBOLargeFormatTip.BACKLAMINATES + '\')', {
                    id: 'backLaminateTip',
                    cssClass: 'quoteHelp',
                    tabindex: '-1',
                    title: 'More Information'
                });
            }

            if (this.model.isEditBackLaminate()) {
                content += help + '<label class="config">' + this.model.getBackLaminateLabel() + '</label>';

                var allowNone = !this.model.isBackLaminateRequired() && this.model.isBackLaminateAllowNone();

                var renderList = clist;
                var showNullOption = allowNone;
                if (clist.length === 0 && allowNone) {
                    cselected = null;
                    renderList = [{ id: null, name: 'None' }];
                    showNullOption = false;
                }

                content += forms.dd(fieldName, renderList, cselected, {
                    showNullOption: showNullOption,
                    nullOption: 'None',
                    cssClass: 'configSelect' + (error ? ' error' : ''),
                    onchange: 'controller.setBackLaminate()'
                });
                if (error) {
                    content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
                }
            } else {
                var cdefault = this.model.getDefaultBackLaminate();
                if (cdefault != null) {
                    content += help + '<label class="config">' + this.model.getBackLaminateLabel() + '</label>';
                    content += tags.div(cdefault.name, {
                        cssClass: 'noEdit'
                    });
                }
            }
            common.setOptionDiv('backLaminate', content);
        }
    },
    setBackLaminate: function () {
        var newValue = getDropDownSelectedValue('BACKLAMINATEDD', document);

        var configChangeDetails = {
            context: 'setBackLaminate',
            category: confUtil.FIELD_CHANGE,
            fieldName: 'BACKLAMINATEDD',
            fieldType: 'DD',
            previousValue: null,
            newValue: newValue
        };

        this.model.setBackLaminate(+newValue);

        configureEvents.onCalcChanged(configChangeDetails);

        this.updateQuote(configChangeDetails);
    },
    setWidth: function () {
        this.validateAndSetDimension('WIDTHEF', 'setWidth', 'Width must be a number.');
    },
    setHeight: function () {
        this.validateAndSetDimension('HEIGHTEF', 'setHeight', 'Height must be a number.');
    },
    validateAndSetDimension: function (fieldName, context, errorFieldValue) {
        var cquotedata = configureglobals.cquotedata;
        var enteredDimension = getFormItemValue(fieldName, document);

        var isEmpty = !enteredDimension || !enteredDimension.trim().length;
        if (isEmpty || isNumber(enteredDimension)) {
            common.efBlur(fieldName, 'dimensionsDiv', 'dimensionsFocus', function (newValue) {
                if (fieldName === 'WIDTHEF') {
                    controller.model.setWidth(+newValue);
                } else if (fieldName === 'HEIGHTEF') {
                    controller.model.setHeight(+newValue);
                }
            });
        } else if (isNaN(enteredDimension)) {
            cquotedata.clearFieldErrors('WIDTHEF');
            cquotedata.clearFieldErrors('HEIGHTEF');
            cquotedata.clearGlobalErrors();

            cquotedata.addFieldError('WIDTHEF', errorFieldValue);
            cquotedata.addGlobalError('A quote was not completed.  Please make adjustments.');
            var content = '<ul class="validationErrorMessage"><li>A quote was not completed.  Please make adjustments.<li><ul>';
            dynamic.setDivIdContent('validationMessagesDiv', content);

            common.setCQuote(null);
            this.generateDimensions();

            var configChangeDetails = {
                context: context,
                category: confUtil.FIELD_CHANGE,
                fieldName: fieldName,
                fieldType: 'EF',
                previousValue: null,
                newValue: null
            };
            configureEvents.onQuoteUpdated(configChangeDetails);
        }
    },
    generateOperations: function () {
        var content = '';
        var coperationdata = this.model.operations;
        var operationGroups = this.model.operationGroups;

        // TT-363 fallout: privileged mode reveals operations the storefront hides, but
        // prepareOperationGroupData drops anything that is not visible. Visibility has to be
        // resolved for every operation BEFORE grouping -- a hidden operation that belongs to a
        // group is otherwise discarded and can never be revealed. An ungrouped one survives via
        // the automatic 'Other' group, which is why this only bites sites that have an
        // operation group set linked.
        resolveOperationVisibility(coperationdata);

        var groupData = prepareOperationGroupData(operationGroups || [], coperationdata);

        if (groupData.length && coperationdata) {
            for (var i = 0, className = ''; i < groupData.length; i++) {
                className = generateClassName(groupData[i].label);

                content += '<div class="operationsGroupWrapper operationsGroupWrapper--' + className + '">';
                content += '<h3>' + groupData[i].label + '</h3>';
                content += '<fieldset class="operationsGroup">';
                for (var j = 0; j < groupData[i].operations.length; j++) {
                    content += prepareOperationMarkup(groupData[i].operations[j], groupData[i].operations[j].originalIndex);
                }
                content += '</fieldset>';
                content += '</div>';
            }
        } else if (coperationdata) {
            for (var i = 0; i < coperationdata.length; i++) {
                content += prepareOperationMarkup(coperationdata[i], i);
            }
        }

        if (content.length && !operationGroups) {
            content = '<h3>Finishing</h3><fieldset class="operationsGroup">' + content + '</fieldset>';
        }

        if (dynamic.divIdExists('operationsDiv')) {
            dynamic.setClass('operationsDiv', !content.length ? 'optionWrapperEmpty' : '');
            dynamic.setDivIdContent('operationsDiv', content);
        }
        this.refreshOperationFieldErrorMessages();

        return;

        function generateClassName (label) {
            return label
                .trim()
                .toLowerCase()
                .replace(/\s\s*/g, '-');
        }

        // Resolves, for each operation, whether it renders at all and whether it renders as
        // "internal only". Kept out of prepareOperationMarkup so that grouping and markup agree
        // on one answer, and deliberately does NOT mutate lpjcOperation.show: the model outlives
        // a render, so a mutated flag would leak into the next pass.
        function resolveOperationVisibility (opData) {
            if (!opData) {
                return;
            }

            var privileged = controller.model.isQuoteModePrivileged();

            for (var oi = 0; oi < opData.length; oi++) {
                var op = opData[oi];
                var configuredShow = op.lpjcOperation.show === true;
                var choiceCount = op.choices ? op.choices.length : 0;

                op.internalOnly = privileged && !configuredShow;

                // an internal-only operation with fewer than two choices offers nothing to pick
                op.visible = op.internalOnly ? choiceCount >= 2 : configuredShow;
            }
        }

        function prepareOperationMarkup (operationData, i) {
            var content = '';
            var ddName = 'OPERATIONDD';
            var anoperationdata = coperationdata[i];
            var cchoices = anoperationdata.choices;
            var cchoice = anoperationdata.choice;
            var clpjcoperation = anoperationdata.lpjcOperation;
            var coperation = clpjcoperation.operation;
            var help = '';
            var fieldName,
                dderror,
                costType,
                efName,
                eferror,
                focusSurround,
                focusButton,
                aName;
            var internalOnly = anoperationdata.internalOnly;
            var getChoiceDisplayName = function (cchoice) {
                var displayName = cchoice.name;
                if (cchoice.adminOnly) {
                    displayName += ' (Internal Only)';
                }
                return displayName;
            };

            // visibility and the internal-only flag are resolved up front, before grouping
            if (controller.model.isQuoteModePrivileged()) {
                clpjcoperation.editable = true;
            }

            if (anoperationdata.visible) {
                if (clpjcoperation.showTip) {
                    help = tags.a('', 'javascript:help.lfOpTip(' + i + ')', {
                        id: 'opTip' + i,
                        cssClass: 'quoteHelp',
                        tabindex: '-1',
                        title: 'More Information'
                    });
                }

                content += '<div class="optionWrapperOn' + (coperation.costingOnly ? ' costingOnly' : '') + '" id="operation' + coperation.id + '">';

                if (internalOnly) {
                    content += help + '<label class="config internal-only">' + strWeb(coperation.heading) + ' (Internal Only)</label>';
                } else {
                    content += help + '<label class="config">' + strWeb(coperation.heading) + '</label>';
                }

                if (clpjcoperation.editable) {
                    fieldName = ddName + i;
                    dderror = common.validation.hasJobQuoteFieldMessagesFor(fieldName);

                    content += forms.dd(fieldName, cchoices, cchoice, {
                        showNullOption: clpjcoperation.showNoneItem,
                        nullOption: 'None',
                        cssClass: dderror ? 'opSelectError' : 'opSelect',
                        onchange: 'controller.setOperation(' + i + ', ' + coperation.id + ')',
                        id: 'operation' + coperation.id,
                        propertyFunction: getChoiceDisplayName
                    });

                    content += '<div id="' + fieldName + 'FieldErrorMessage"><!-- dynamic --></div>';
                } else {
                    if (cchoice) {
                        content += tags.div(strWeb(cchoice.name), {
                            cssClass: 'noEdit'
                        });
                    }
                }

                // item question
                if (cchoice) {
                    costType = cchoice.costType;

                    if (costType === largeFormatGlobals.OPITEM_QUANTITY && cchoice.editableValues) {
                        efName = 'OPERATIONQUANTITYEF' + i;
                        eferror = common.validation.hasJobQuoteFieldMessagesFor(efName);
                        focusSurround = efName + 'Surround';
                        focusButton = efName + 'Focus';

                        content += '<div class="op lf">';
                        content += '<div id="' + focusSurround + '" >';
                        content += '<label class="opQuestion">How many per quantity?</label>';
                        content += forms.ef(efName, anoperationdata.quantity, {
                            size: 10,
                            cssClass: 'configField' + (eferror ? ' error' : ''),
                            onfocus: 'common.efFocus(\'' + efName + '\',\'' + focusSurround + '\', \'' + focusButton + '\')',
                            onblur: 'controller.setOperationQuantity(' + i + ',' + anoperationdata.id + ')',
                            id: 'operationQuantity' + coperation.id
                        });
                        content += '<span id="' + focusButton + '" class="changeFocusButton"><!-- dynamic --></span>';
                        content += '<div id="' + efName + 'FieldErrorMessage"><!-- dynamic --></div>';
                        content += '</div>';
                        content += '</div>';
                    } else if (costType === largeFormatGlobals.OPITEM_LINEAR_FEET && cchoice.editableValues) {
                        aName = ddName + '_CB';
                        content += '<div class="op lf">';
                        content += '<label class="opQuestion">Select applicable edges</label>';
                        content += '<div class="configCheckbox"><label class="configCheckbox-label"><input id="operationLinearFeetTop' + coperation.id + '" onchange="controller.setOperationTop(' + i + ',' + coperation.id + ')" type="checkbox" name="' + aName + '_TOP_' + i + '" class="configCheckbox-input" ' + (anoperationdata.topSide ? 'checked' : '') + ' />Top</label></div>';
                        content += '<div class="configCheckbox"><label class="configCheckbox-label"><input id="operationLinearFeetBottom' + coperation.id + '" onchange="controller.setOperationBottom(' + i + ',' + coperation.id + ')" type="checkbox" name="' + aName + '_BOTTOM_' + i + '" class="configCheckbox-input" ' + (anoperationdata.bottomSide ? 'checked' : '') + ' />Bottom</label></div>';
                        content += '<div class="configCheckbox"><label class="configCheckbox-label"><input id="operationLinearFeetLeft' + coperation.id + '" onchange="controller.setOperationLeft(' + i + ',' + coperation.id + ')" type="checkbox" name="' + aName + '_LEFT_' + i + '" class="configCheckbox-input" ' + (anoperationdata.leftSide ? 'checked' : '') + ' />Left</label></div>';
                        content += '<div class="configCheckbox"><label class="configCheckbox-label"><input id="operationLinearFeetRight' + coperation.id + '" onchange="controller.setOperationRight(' + i + ',' + coperation.id + ')" type="checkbox" name="' + aName + '_RIGHT_' + i + '" class="configCheckbox-input" ' + (anoperationdata.rightSide ? 'checked' : '') + ' />Right</label></div>';
                        content += '</div>';
                    } else if ((costType === largeFormatGlobals.OPITEM_COSTED_ADD_ON
                            || costType === largeFormatGlobals.OPITEM_DIRECT_ADD_ON
                            || costType === largeFormatGlobals.OPITEM_COSTED_ADD_ON_PER_PIECE)
                        && cchoice.editableValues) {
                        efName = 'OPERATION_ADD_ON_VALUE_EF' + i;
                        eferror = common.validation.hasJobQuoteFieldMessagesFor(efName);
                        focusSurround = efName + 'Surround';
                        focusButton = efName + 'Focus';

                        content += '<div class="op lf">';
                        content += '<div id="' + focusSurround + '" >';
                        content += '<label class="opQuestion">How much per job?</label>';
                        content += forms.ef(efName, anoperationdata.addOnValue, {
                            size: 10,
                            cssClass: 'configField' + (eferror ? ' error' : ''),
                            onfocus: 'common.efFocus(\'' + efName + '\',\'' + focusSurround + '\', \'' + focusButton + '\')',
                            onblur: 'controller.setOperationAddOnValue(' + i + ',' + anoperationdata.id + ')',
                            id: 'operationAddOnValue' + coperation.id
                        });
                        content += '<span id="' + focusButton + '" class="changeFocusButton"><!-- dynamic --></span>';
                        content += '<div id="' + efName + 'FieldErrorMessage"><!-- dynamic --></div>';
                        content += '</div>';
                        content += '</div>';
                    } else if (costType === largeFormatGlobals.OPITEM_QUANTITY_DIVISOR && cchoice.editableValues) {
                        efName = 'OPERATION_QUANTITY_DIVISOR_EF' + i;
                        eferror = common.validation.hasJobQuoteFieldMessagesFor(efName);
                        focusSurround = efName + 'Surround';
                        focusButton = efName + 'Focus';

                        content += '<div class="op lf">';
                        content += '<div id="' + focusSurround + '" >';
                        content += '<label class="opQuestion">What is the denominator?</label>';
                        content += forms.ef(efName, anoperationdata.quantityDivisor, {
                            size: 10,
                            cssClass: 'configField' + (eferror ? ' error' : ''),
                            onfocus: 'common.efFocus(\'' + efName + '\',\'' + focusSurround + '\', \'' + focusButton + '\')',
                            onblur: 'controller.setOperationQuantityDivisor(' + i + ',' + anoperationdata.id + ')',
                            id: 'operationQuantityDivisor' + coperation.id
                        });
                        content += '<span id="' + focusButton + '" class="changeFocusButton"><!-- dynamic --></span>';
                        content += '<div id="' + efName + 'FieldErrorMessage"><!-- dynamic --></div>';
                        content += '</div>';
                        content += '</div>';
                    }
                }
                content += '</div><!-- optionWrapper -->';
            }

            return content;
        }

        function prepareOperationGroupData (groups, opData) {
            var operationGroupData = [];
            var operations;

            if (!groups || !groups.length || !opData) {
                return operationGroupData;
            }

            // We are going to alter the array, make a copy of it
            // to leave original intact for other users
            operationData = opData.slice();

            // Save original index for use in things like tips etc...
            for (var i = 0; i < operationData.length; i++) {
                operationData[i].originalIndex = i;
            }

            // Loop through groups and match any listed operations
            // to operationData items returned for this product
            for (var j = 0, entry, tempOperations; j < groups.length; j++) {
                entry = {
                    label: groups[j].label,
                    operations: []
                };

                tempOperations = [];

                for (var k = 0, ii; k < groups[j].operations.length; k++) {
                    ii = 0;
                    while (ii < operationData.length) {
                        if (groups[j].operations[k].id === operationData[ii].lpjcOperation.operation.id) {
                            if (operationData[ii].visible) {
                                tempOperations.push(operationData[ii]);
                            }
                            operationData.splice(ii, 1);
                            continue;
                        }
                        ii++;
                    }
                }

                if (tempOperations.length) {
                    entry.operations = tempOperations;
                    operationGroupData.push(entry);
                }
            }

            // If there are any operationData items not sorted into a group yet,
            // add them to a catch all group
            if (operationData.length) {
                operationGroupData.push({
                    label: 'Other',
                    operations: operationData
                });
            }

            return operationGroupData;
        }
    },
    refreshOperationFieldErrorMessages: function () {
        var coperationdata = configureglobals.coperationdata.list;
        if (coperationdata == null) {
            return;
        }
        for (var i = 0; i < coperationdata.length; i++) {
            var anoperationdata = coperationdata[i];
            var clpjcoperation = anoperationdata.lpjcOperation;
            var coperation = clpjcoperation.operation;
            var cchoices = anoperationdata.choices;
            var cchoice = anoperationdata.choice;
            var content = '';

            // dd
            var fieldName = 'OPERATIONDD' + i;
            var dderror = common.validation.hasJobQuoteFieldMessagesFor(fieldName);
            if (dderror) {
                content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
            }
            dynamic.setDivIdContent(fieldName + 'FieldErrorMessage', content);
            content = '';

            // item question
            if (cchoice != null) {
                var costType = cchoice.costType;

                var efName = null;
                var eferror = null;
                if (costType === largeFormatGlobals.OPITEM_QUANTITY && cchoice.editableValues) {
                    efName = 'OPERATIONQUANTITYEF' + i;
                } else if ((costType === largeFormatGlobals.OPITEM_COSTED_ADD_ON
                        || costType === largeFormatGlobals.OPITEM_DIRECT_ADD_ON
                        || costType === largeFormatGlobals.OPITEM_COSTED_ADD_ON_PER_PIECE)
                    && cchoice.editableValues) {
                    efName = 'OPERATION_ADD_ON_VALUE_EF' + i;
                } else if (costType === largeFormatGlobals.OPITEM_QUANTITY_DIVISOR && cchoice.editableValues) {
                    efName = 'OPERATION_QUANTITY_DIVISOR_EF' + i;
                }
                eferror = common.validation.hasJobQuoteFieldMessagesFor(efName);
                if (eferror) {
                    content += common.validation.generateJobQuoteFieldMessagesFor(efName);
                }
                dynamic.setDivIdContent(efName + 'FieldErrorMessage', content);
            }
        }
    },
    setOperationQuantity: function (index, opId) {
        var cquotedata = configureglobals.cquotedata;

        var efName = 'OPERATIONQUANTITYEF' + index;
        var focusSurround = efName + 'Surround';
        var focusButton = efName + 'Focus';

        var model = this.model;

        var enteredValue = getFormItemValue(efName, document);
        var parsedValue = parseInt(enteredValue);

        cquotedata.clearFieldErrors(efName);
        cquotedata.clearGlobalErrors();

        if (enteredValue && enteredValue.trim().length > 0 && isNaN(parsedValue)) {
            cquotedata.addFieldError(efName, 'Quantity must be a number.');
            cquotedata.addGlobalError('A quote was not completed.  Please make adjustments.');

            var content = '<ul class="validationErrorMessage"><li>A quote was not completed.  Please make adjustments.<li><ul>';
            dynamic.setDivIdContent('validationMessagesDiv', content);

            common.setCQuote(null);
            this.refreshOperationFieldErrorMessages();

            var configChangeDetails = {
                context: 'setOperationQuantity',
                category: confUtil.INDEXED_FIELD_CHANGE,
                fieldNamePrefix: 'OPERATIONDD',
                fieldType: 'DD',
                fieldIndex: index,
                previousValue: null,
                newValue: enteredValue
            };

            configureEvents.onQuoteUpdated(configChangeDetails);
        } else {
            common.efBlur(efName, focusSurround, focusButton, function (newValue) {
                model.setOperationQuantity(opId, +newValue);
            });
        }
    },
    setOperationQuantityDivisor: function (index, opId) {
        var efName = 'OPERATION_QUANTITY_DIVISOR_EF' + index;
        var focusSurround = efName + 'Surround';
        var focusButton = efName + 'Focus';

        var model = this.model;

        common.efBlur(efName, focusSurround, focusButton, function (newValue) {
            model.setOperationQuantityDivisor(opId, +newValue);
        });
    },
    setOperationAddOnValue: function (index, opId) {
        var efName = 'OPERATION_ADD_ON_VALUE_EF' + index;
        var focusSurround = efName + 'Surround';
        var focusButton = efName + 'Focus';

        var model = this.model;

        common.efBlur(efName, focusSurround, focusButton, function (newValue) {
            model.setOperationAddOnValue(opId, +newValue);
        });
    },
    setOperationTop: function (index, opId) {
        var operation = this.model.getOperationById(opId);

        var configChangeDetails = {
            context: 'setOperationTop',
            category: confUtil.INDEXED_FIELD_CHANGE,
            fieldNamePrefix: 'OPERATIONDD',
            fieldType: 'DD',
            fieldIndex: index,
            previousValue: operation.topSide,
            newValue: !operation.topSide
        };

        operation.topSide = !operation.topSide;

        configureEvents.onCalcChanged(configChangeDetails);

        this.updateQuote(configChangeDetails);
    },
    setOperationBottom: function (index, opId) {
        var operation = this.model.getOperationById(opId);

        var configChangeDetails = {
            context: 'setOperationBottom',
            category: confUtil.INDEXED_FIELD_CHANGE,
            fieldNamePrefix: 'OPERATIONDD',
            fieldType: 'DD',
            fieldIndex: index,
            previousValue: operation.bottomSide,
            newValue: !operation.bottomSide
        };

        operation.bottomSide = !operation.bottomSide;

        configureEvents.onCalcChanged(configChangeDetails);

        this.updateQuote(configChangeDetails);
    },
    setOperationLeft: function (index, opId) {
        var operation = this.model.getOperationById(opId);

        var configChangeDetails = {
            context: 'setOperationLeft',
            category: confUtil.INDEXED_FIELD_CHANGE,
            fieldNamePrefix: 'OPERATIONDD',
            fieldType: 'DD',
            fieldIndex: index,
            previousValue: operation.leftSide,
            newValue: !operation.leftSide
        };

        operation.leftSide = !operation.leftSide;

        configureEvents.onCalcChanged(configChangeDetails);

        this.updateQuote(configChangeDetails);
    },
    setOperationRight: function (index, opId) {
        var operation = this.model.getOperationById(opId);

        var configChangeDetails = {
            context: 'setOperationRight',
            category: confUtil.INDEXED_FIELD_CHANGE,
            fieldNamePrefix: 'OPERATIONDD',
            fieldType: 'DD',
            fieldIndex: index,
            previousValue: operation.rightSide,
            newValue: !operation.rightSide
        };

        operation.rightSide = !operation.rightSide;

        configureEvents.onCalcChanged(configChangeDetails);

        this.updateQuote(configChangeDetails);
    },
    setOperation: function (index, opId) {
        var newChoiceId = parseInt(getDropDownSelectedValue('OPERATIONDD' + index, document));

        var configChangeDetails = {
            context: 'setOperation',
            category: confUtil.INDEXED_FIELD_CHANGE,
            fieldIndex: index,
            fieldNamePrefix: 'OPERATIONDD',
            fieldType: 'DD',
            previousValue: null,
            newValue: newChoiceId
        };

        this.model.setOperationChoice(opId, +newChoiceId);

        configureEvents.onCalcChanged(configChangeDetails);

        this.updateQuote(configChangeDetails);
    },
    parentController: null,
    onLargeQuoteComplete: function (success) {
        if (this.parentController != null) {
            this.parentController.largeQuoteComplete(success);
        }
        if (typeof shippingCalcWidgetController == 'object') {
            shippingCalcWidgetController.onQuoteChange();
        }
    },
    generateOverrideAmountDiv: function () {
        if (dynamic.divIdExists('overrideAmountDiv') && this.model.isQuoteModePrivileged()) {
            var fieldName = 'TOTAL_PRICE_OVERRIDE_AMOUNT_EF';
            var content = '';
            var error = common.validation.hasJobQuoteFieldMessagesFor(fieldName);

            content += '<h3>Price Adjustment</h3>';
            content += forms.ef(fieldName, this.model.getTotalPriceOverrideAmount(), {
                size: 15,
                style: 'width:auto',
                cssClass: 'configField' + (error ? ' error' : ''),
                onfocus: 'common.efFocus(\'' + fieldName + '\',\'overrideAmountDiv\', \'overrideAmountFocus\')',
                onblur: 'controller.setTotalPriceOverrideAmount()'
            });
            content += '<span id="overrideAmountFocus" class="changeFocusButton"><!-- dynamic --></span>';
            if (error) {
                content += common.validation.generateJobQuoteFieldMessagesFor(fieldName);
            }
            common.setOptionDiv('overrideAmountDiv', content);
        }
    },
    generatePieceMargin: function () {
        if (!this.model.isShowPieceMargin()) {
            return;
        }

        var edit = this.model.isEditPieceMargin();
        var content = '';

        if (this.model.isShowPieceMarginTip()) {
            content += this.generateHelpTip('pieceMarginTip', TBGBOLargeFormatTip.PIECE_MARGIN);
        }

        content += '<label id="pieceMarginHeaderLabel" class="config">' + TBGBOLargeFormatTip.PIECE_MARGIN + '</label>';

        content += this.generateField('PIECE_MARGIN_TOP_EF', 'Top', this.model.pieceMarginTop, 'pieceMargin', edit, 'controller.onPieceMarginTopBlur()');
        content += this.generateField('PIECE_MARGIN_BOTTOM_EF', 'Bottom', this.model.pieceMarginBottom, 'pieceMargin', edit, 'controller.onPieceMarginBottomBlur()');
        content += this.generateField('PIECE_MARGIN_LEFT_EF', 'Left', this.model.pieceMarginLeft, 'pieceMargin', edit, 'controller.onPieceMarginLeftBlur()');
        content += this.generateField('PIECE_MARGIN_RIGHT_EF', 'Right', this.model.pieceMarginRight, 'pieceMargin', edit, 'controller.onPieceMarginRightBlur()');

        common.setOptionDiv('pieceMargin', content);
    },
    generatePieceBleed: function () {
        if (!this.model.isShowPieceBleed()) {
            return;
        }

        var edit = this.model.isEditPieceBleed();
        var content = '';

        if (this.model.isShowPieceBleedTip()) {
            content += this.generateHelpTip('pieceBleedTip', TBGBOLargeFormatTip.PIECE_BLEED);
        }

        content += '<label id="pieceBleedHeaderLabel" class="config">' + TBGBOLargeFormatTip.PIECE_BLEED + '</label>';

        content += this.generateField('PIECE_BLEED_TOP_EF', 'Top', this.model.pieceBleedTop, 'pieceBleed', edit, 'controller.onPieceBleedTopBlur()');
        content += this.generateField('PIECE_BLEED_BOTTOM_EF', 'Bottom', this.model.pieceBleedBottom, 'pieceBleed', edit, 'controller.onPieceBleedBottomBlur()');
        content += this.generateField('PIECE_BLEED_LEFT_EF', 'Left', this.model.pieceBleedLeft, 'pieceBleed', edit, 'controller.onPieceBleedLeftBlur()');
        content += this.generateField('PIECE_BLEED_RIGHT_EF', 'Right', this.model.pieceBleedRight, 'pieceBleed', edit, 'controller.onPieceBleedRightBlur()');

        common.setOptionDiv('pieceBleed', content);
    },
    generateInstallerBleed: function () {
        if (!this.model.isShowInstallerBleed()) {
            return;
        }

        var edit = this.model.isEditInstallerBleed();
        var content = '';

        if (this.model.isShowInstallerBleedTip()) {
            content += this.generateHelpTip('installerBleedTip', TBGBOLargeFormatTip.INSTALLER_BLEED);
        }

        content += '<label id="installerBleedHeaderLabel" class="config">' + TBGBOLargeFormatTip.INSTALLER_BLEED + '</label>';

        content += this.generateField('INSTALLER_BLEED_TOP_EF', 'Top', this.model.installerBleedTop, 'installerBleed', edit, 'controller.onInstallerBleedTopBlur()');
        content += this.generateField('INSTALLER_BLEED_BOTTOM_EF', 'Bottom', this.model.installerBleedBottom, 'installerBleed', edit, 'controller.onInstallerBleedBottomBlur()');
        content += this.generateField('INSTALLER_BLEED_LEFT_EF', 'Left', this.model.installerBleedLeft, 'installerBleed', edit, 'controller.onInstallerBleedLeftBlur()');
        content += this.generateField('INSTALLER_BLEED_RIGHT_EF', 'Right', this.model.installerBleedRight, 'installerBleed', edit, 'controller.onInstallerBleedRightBlur()');

        common.setOptionDiv('installerBleed', content);
    },
    generateHelpTip: function (fieldName, globalName) {
        return tags.a('', 'javascript:help.tip(configureglobals.clpjc,\'' + fieldName + '\',\'' + globalName + '\')', {
            id: fieldName,
            cssClass: 'quoteHelp',
            tabindex: '-1',
            title: 'More Information'
        });
    },
    onPieceMarginTopBlur: function () {
        common.efBlur('PIECE_MARGIN_TOP_EF', 'pieceMargin', 'PIECE_MARGIN_TOP_EF_FOCUS', function (newValue) {
            controller.model.setPieceMarginTop(+newValue);
        });
    },
    onPieceMarginBottomBlur: function () {
        common.efBlur('PIECE_MARGIN_BOTTOM_EF', 'pieceMargin', 'PIECE_MARGIN_BOTTOM_EF_FOCUS', function (newValue) {
            controller.model.setPieceMarginBottom(+newValue);
        });
    },
    onPieceMarginLeftBlur: function () {
        common.efBlur('PIECE_MARGIN_LEFT_EF', 'pieceMargin', 'PIECE_MARGIN_LEFT_EF_FOCUS', function (newValue) {
            controller.model.setPieceMarginLeft(+newValue);
        });
    },
    onPieceMarginRightBlur: function () {
        common.efBlur('PIECE_MARGIN_RIGHT_EF', 'pieceMargin', 'PIECE_MARGIN_RIGHT_EF_FOCUS', function (newValue) {
            controller.model.setPieceMarginRight(+newValue);
        });
    },
    onPieceBleedTopBlur: function () {
        common.efBlur('PIECE_BLEED_TOP_EF', 'pieceBleed', 'PIECE_BLEED_TOP_EF_FOCUS', function (newValue) {
            controller.model.setPieceBleedTop(+newValue);
        });
    },
    onPieceBleedBottomBlur: function () {
        common.efBlur('PIECE_BLEED_BOTTOM_EF', 'pieceBleed', 'PIECE_BLEED_BOTTOM_EF_FOCUS', function (newValue) {
            controller.model.setPieceBleedBottom(+newValue);
        });
    },
    onPieceBleedLeftBlur: function () {
        common.efBlur('PIECE_BLEED_LEFT_EF', 'pieceBleed', 'PIECE_BLEED_LEFT_EF_FOCUS', function (newValue) {
            controller.model.setPieceBleedLeft(+newValue);
        });
    },
    onPieceBleedRightBlur: function () {
        common.efBlur('PIECE_BLEED_RIGHT_EF', 'pieceBleed', 'PIECE_BLEED_RIGHT_EF_FOCUS', function (newValue) {
            controller.model.setPieceBleedRight(+newValue);
        });
    },
    onInstallerBleedTopBlur: function () {
        common.efBlur('INSTALLER_BLEED_TOP_EF', 'installerBleed', 'INSTALLER_BLEED_TOP_EF_FOCUS', function (newValue) {
            controller.model.setInstallerBleedTop(+newValue);
        });
    },
    onInstallerBleedBottomBlur: function () {
        common.efBlur('INSTALLER_BLEED_BOTTOM_EF', 'installerBleed', 'INSTALLER_BLEED_BOTTOM_EF_FOCUS', function (newValue) {
            controller.model.setInstallerBleedBottom(+newValue);
        });
    },
    onInstallerBleedLeftBlur: function () {
        common.efBlur('INSTALLER_BLEED_LEFT_EF', 'installerBleed', 'INSTALLER_BLEED_LEFT_EF_FOCUS', function (newValue) {
            controller.model.setInstallerBleedLeft(+newValue);
        });
    },
    onInstallerBleedRightBlur: function () {
        common.efBlur('INSTALLER_BLEED_RIGHT_EF', 'installerBleed', 'INSTALLER_BLEED_RIGHT_EF_FOCUS', function (newValue) {
            controller.model.setInstallerBleedRight(+newValue);
        });
    },
    generateField: function (fieldName, label, value, containerDiv, edit, onBlur) {
        var fieldHasError = common.validation.hasJobQuoteFieldMessagesFor(fieldName);

        var content = '';

        content += '<label class="config">' + label + '</label>';

        if (edit) {
            content += forms.ef(fieldName, value, {
                size: 10,
                cssClass: 'configField' + (fieldHasError ? ' error' : ''),
                onfocus: 'common.efFocus(\'' + fieldName + '\',\'' + containerDiv + '\', \'' + fieldName + '_FOCUS\')',
                onblur: onBlur
            });
        } else {
            content += tags.div(value, { cssClass: 'noEdit' });
        }

        content += '<span id="' + fieldName + '_FOCUS" class="changeFocusButton"><!-- dynamic --></span>';

        if (fieldHasError) {
            content += '<div id="' + fieldName + '_FIELD_ERROR_MESSAGE">' + common.validation.generateJobQuoteFieldMessagesFor(fieldName) + '</div>';
        }

        return content;
    },
    display: function () {
        quantityConfigureController.generateQuantity();
        controller.generateDimensions();
        controller.generateSides();
        controller.generatePrintSubstrates();
        controller.generateMountSubstrates();
        controller.generateFrontLaminates();
        controller.generateBackLaminates();
        controller.generateOverrideAmountDiv();
        controller.generateOperations();
        controller.generatePieceMargin();
        controller.generatePieceBleed();
        controller.generateInstallerBleed();

        common.generateProofs();
        common.generateTurnaroundTimes();

        var isRequoteMode = !!configureCommonGlobals.REQUOTE_MODE;
        var isFullQuoteMode = this.mode === controllerMode.FULL_QUOTE;
        if (!isRequoteMode && !isFullQuoteMode) {
            common.generateAdditionalFields();
        }
    },
    fetchProductionTasks: function (request) {
        return new Promise(function (resolve, reject) {
            $.ajax({
                url: '/rest/internal/supplierAdmin/products/productionTasks/custom',
                method: 'POST',
                accept: 'application/json',
                contentType: 'application/json',
                data: request,
                success: function (quoteResponse) {
                    resolve(quoteResponse);
                },
                error: function (errorResponse) {
                    console.error('Error fetching production tasks');
                    reject(errorResponse);
                }
            });
        });
    },
    getProductionTasks: function (quoteRequest) {
        return this.isCustomQuote() ? this.fetchProductionTasks(quoteRequest) : Promise.resolve();
    },
    isCustomQuote: function () {
        return configureCommonGlobals && configureCommonGlobals.SALES_ESTIMATE_MODE === true;
    },
    getQuoteURL: function () {
        if (this.isCustomQuote()) {
            return this.QUOTE_URLS.CUSTOM;
        }

        if (configureCommonGlobals && configureCommonGlobals.REQUOTE_MODE === true) {
            return this.QUOTE_URLS.REQUOTE;
        }

        return USER_TYPE === this.USER_TYPES.SUPPLIER_ADMIN
            ? this.QUOTE_URLS.EXTENDED
            : this.QUOTE_URLS.DEFAULT;
    },
    lastRequestId: 0,
    getQuote: function (isLogin, onQuoteUpdatedFunction, onQuoteUpdateFailedFunction) {
        dynamic.setDivIdContent('jobQuote', '--');

        // Disable "Continue" button until quote successfully generated
        common.setContinueButtonEnabled(false);

        var requestId = ++this.lastRequestId;
        var self = this;

        var quoteRequest = JSON.stringify(this.model.generateQuoteRequestData());

        var quotePromise = tbg.apiV2({
            url: controller.getQuoteURL(),
            urlPrefix: '',
            method: 'POST',
            contentType: 'application/json',
            data: quoteRequest,
            suppressDefaultMessages: true,
            errorHandlers: {
                417: function (response) {
                    if (requestId !== controller.lastRequestId) {
                        return;
                    }
                    common.setCQuoteData(new LargeQuoteDataAdapter(controller.model, response));
                    common.setCQuote(null);
                    controller.onLargeQuoteComplete(null);
                    if (typeof onQuoteUpdatedFunction === 'function') {
                        onQuoteUpdatedFunction();
                    }
                },
                default: function (response) {
                    if (requestId !== controller.lastRequestId) {
                        return;
                    }
                    common.setCQuote(null);
                    controller.onLargeQuoteComplete(null);
                    if (typeof onQuoteUpdateFailedFunction === 'function') {
                        onQuoteUpdateFailedFunction();
                    }
                    configureEvents.onQuoteUpdated(null);
                    var errors = response && response.errors;
                    if (errors && errors.length) {
                        errors.forEach(function (e) {
                            growlMessages.showErrorMessage(e.detail);
                        });
                    } else {
                        growlMessages.showErrorMessage('An error occurred while getting a quote. Please try again.');
                    }
                }
            }
        });

        var productionTasksPromise = this.getProductionTasks(quoteRequest)
            .catch(function () {
                console.error('Error fetching production tasks');
                return null;
            });

        return Promise.all([quotePromise, productionTasksPromise])
            .then(function (responses) {
                var quoteResponse = responses[0];
                var productionTasksResponse = responses[1];

                if (!quoteResponse || requestId !== controller.lastRequestId) {
                    return;
                }

                var quote = quoteResponse.content;
                var productionTasks = productionTasksResponse && productionTasksResponse.content;

                if (productionTasks) {
                    window.tbg.eventHub.trigger(window.tbg.eventHub.events.PRODUCTION_PLAN_SET, [productionTasks]);
                } else {
                    window.tbg.eventHub.trigger(window.tbg.eventHub.events.PRODUCTION_PLAN_SET, [[]]);
                }

                common.setCQuote(USER_TYPE === 'SUPPLIER_ADMIN'
                    ? new ExtendedQuoteAdapter(controller.model, quote)
                    : new LargeQuoteAdapter(controller.model, quote));
                common.setCQuoteData(new LargeQuoteDataAdapter(controller.model, quote));

                controller.validateBackLaminateWarnings(quoteResponse);
                common.showValidationMessages(quoteResponse, !self.parentController);

                controller.onLargeQuoteComplete(configureglobals.cquote != null);
                if (common.ef != null) {
                    focusOn(common.ef, document);
                    selectAll(common.ef, document);
                }
                if (typeof onQuoteUpdatedFunction === 'function') {
                    onQuoteUpdatedFunction();
                    common.setContinueButtonEnabled(true);
                }
            });
    },

    validateBackLaminateWarnings: function (quoteResponse) {
        var choice = controller.model.backLaminateChoice;
        var backLaminates = controller.model.getBackLaminates();
        var backLaminateWarningMessage = 'Quote Warnings: [Back Laminate choice no longer available]';

        if (choice) {
            var includeChoice = backLaminates.find(function (bl) {
                return bl.id === choice.id;
            });
            if (!includeChoice) {
                quoteResponse.messages = quoteResponse.messages.filter(function (message) {
                    return message.detail.trim() !== backLaminateWarningMessage;
                });
            }
        } else if (!controller.model.isBackLaminateAllowNone() && backLaminates.length > 0) {
            quoteResponse.messages = quoteResponse.messages.filter(function (message) {
                return message.detail.trim() !== backLaminateWarningMessage;
            });
        }
    },
    updateQuote: function (configChangeDetails) {
        return this.getQuote(false, function () {
            this.generateUI(configChangeDetails, { list: [] });
            configureEvents.onQuoteUpdated(configChangeDetails);
        }.bind(this), function () {
            this.generateUI(configChangeDetails, { list: [] });
        }.bind(this));
    },
    setTotalPriceOverrideAmount: function () {
        if (common.validateTotalPriceOverrideAmount(controller.generateOverrideAmountDiv.bind(controller))) {
            return;
        }
        common.efBlur('TOTAL_PRICE_OVERRIDE_AMOUNT_EF', 'overrideAmountDiv', 'overrideAmountFocus', function (newValue) {
            controller.model.setTotalPriceOverrideAmount(+newValue.replace(/,/g, ''));
        });
    }
};

$(function () {
    controller.initialize();
});
